<template>
  <div>
    <v-btn
      v-if="showStickySaveButton"
      color="success"
      size="large"
      variant="elevated"
      @click="Update"
      :loading="dialog"
      :disabled="dialog"
      class="save-action-button-small sticky-save-btn"
      rounded="lg"
    >
      <v-img :src="images.saveImg" width="20" height="20" class="mr-2"></v-img>
      {{ $t('save') }} Changes
    </v-btn>
    <v-container fluid class="pa-6">
      <div class="sticky-tabs-container">
        <v-tabs v-model="selectedTab" class="platform-tabs sticky-tabs" grow hide-slider>
          <v-tab v-for="platform in platformConfig" :key="platform.key" :value="platform.key" class="platform-tab" :class="{ active: selectedTab === platform.key, [`tab-${platform.key}`]: true }">
            <div class="tab-inner">
              <div class="tab-icon-wrapper">
                <!-- <component :is="platform.icon" v-if="platform.icon === 'LineIcon'" :size="30" />
                <component :is="platform.icon" v-if="platform.icon === 'TeamIcon'" :size="30" /> -->

                <!-- <v-icon v-else :icon="platform.icon" size="24"></v-icon> -->
                <LineIcon v-if="platform.key === 'line'" :size="30" :isFill="selectedTab === platform.key" />
                <TeamIcon v-if="platform.key === 'teams'" :size="30" :isFill="selectedTab === platform.key" />
                <FacebookIcon v-if="platform.key === 'facebook'" :size="30" :isFill="selectedTab === platform.key" />
                <InstagramIcon v-if="platform.key === 'instagram'" :size="30" :isFill="selectedTab === platform.key" />
                <SnippetIcon v-if="platform.key === 'snippet'" :size="30" :isFill="selectedTab === platform.key" />

                <v-chip width="40" v-if="getConfigCount(platform.key) > 0" size="x-small" class="tab-chip" color="black" variant="flat">
                  {{ getConfigCount(platform.key) }}
                </v-chip>
              </div>
              <span class="tab-label" :class="{ 'instagram-text-label': 'instagram' === selectedTab && selectedTab === platform.key }">{{ platform.name }}</span>
            </div>
          </v-tab>
        </v-tabs>
      </div>
      <!-- Header Section -->
      <!-- <div class="page-header" style="margin-bottom: 0px">
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("setup_title")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </div> -->
      <div class="config-grid">
        <div>
          <v-container fluid>
            <!-- Platform Selection Tabs -->
            <div class="platform-tabs-container">
              <!-- <v-tabs
                v-model="selectedTab"
                class="modern-tabs"
                color="primary"
                slider-color="primary"
                centered
                grow
              >
                <v-tab
                  v-for="platform in platformConfig"
                  :key="platform.key"
                  :value="platform.key"
                  class="platform-tab"
                  :class="`tab-${platform.key}`"
                >
                  <div class="tab-content">
                    <component
                      :is="platform.icon"
                      v-if="platform.icon === 'LineIcon'"
                      :size="24"
                      color="currentColor"
                    />
                    <v-icon v-else :icon="platform.icon" size="24"></v-icon>
                    <span class="tab-text">{{ platform.name }}</span>
                    <v-chip
                      v-if="getConfigCount(platform.key) > 0"
                      size="small"
                      :color="platform.chipColor"
                      variant="elevated"
                      class="config-count-chip"
                      :class="`chip-${platform.key}`"
                    >
                      <v-icon size="12" class="mr-1">mdi-circle-small</v-icon>
                      {{ getConfigCount(platform.key) }}
                    </v-chip>
                  </div>
                </v-tab>
              </v-tabs> -->

              <!-- Platform Content -->
              <v-window v-model="selectedTab" class="mt-6">
                <!-- LINE Tab -->
                <v-window-item value="line" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large line-gradient">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="34" viewBox="0 0 36 34" fill="none">
                          <path
                            d="M6.60156 10.5996V17.7996H11.4016M13.8016 10.5996V18.5996M17.0016 18.5996V11.3996H17.8016L21.0016 17.7996H21.8016V10.5996M29.0016 11.3996H25.0016V17.7996H29.0016M25.0016 14.5996H29.0016"
                            stroke="white"
                            stroke-width="2"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M17.8 1C8.5216 1 1 7.0896 1 14.6C1 21.4736 7.3008 27.1568 15.48 28.072C16.0944 28.1408 16.6464 28.528 16.7072 29.144C16.832 30.4016 16.5632 32.04 16.2 33C17.7168 33 34.6 24.6224 34.6 14.6C34.6 7.0896 27.0784 1 17.8 1Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div class="platform-details">
                        <h2>LINE Messaging API</h2>
                        <p>Connect your chatbot to LINE using your Channel Secret and Access Token.</p>
                      </div>
                      <div class="platform-actions" v-if="false">
                        <v-btn color="success" variant="flat" size="default" @click="Add('line')" class="compact-text-btn line-btn" rounded="lg">
                          <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                          Add Config
                        </v-btn>
                      </div>
                      <div class="platform-stats">
                        <div class="stat-item">
                          <!-- <span class="stat-number">{{
                            getConfigCount("line")
                          }}</span> -->
                          <span class="stat-label-1">Configurations: {{ getConfigCount('line') }}</span>
                        </div>
                      </div>
                    </div>

                    <v-row justify="end" class="mb-4 mr-2">
                      <v-btn
                        color="success"
                        size="large"
                        variant="elevated"
                        @click="Update"
                        :loading="dialog"
                        :disabled="dialog"
                        prepend-icon="mdi-content-save"
                        class="save-action-button-small"
                        rounded="lg"
                        style="margin-right: 12px"
                      >
                        <template v-slot:prepend>
                          <v-img :src="images.saveImg" width="20" height="20"></v-img>
                        </template>
                        {{ $t('save') }} Changes
                      </v-btn>
                      <v-btn color="success" variant="flat" size="default" @click="Add('line')" rounded="lg" class="outlined-red-btn">
                        <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                        Add Configuration
                      </v-btn>
                    </v-row>

                    <!-- Configurations Grid -->
                    <div v-if="chkDataLine" class="configurations-grid">
                      <div v-if="setupList.filter((item) => item.activeFlag).length === 0" class="empty-state-card">
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2">mdi-chat-outline</v-icon>
                        </div>
                        <h3>No LINE configurations yet</h3>
                        <p>Create your first LINE bot configuration to get started</p>
                        <v-btn color="success" variant="elevated" size="large" @click="Add('line')" class="mt-4">
                          <v-icon left>mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else>
                        <v-expansion-panels variant="accordion" class="mb-4" multiple>
                          <v-expansion-panel
                            v-for="(item, index) in setupList"
                            :key="index"
                            v-show="item.activeFlag"
                            :class="['accordion-custom', { 'accordion-open': expandedPanel === index }]"
                            @change="onExpandChange(index)"
                          >
                            <v-expansion-panel-title class="accordion-title">
                              <div class="d-flex align-center">
                                <img :src="images.gear" alt="addtotable" class="mr-1" style="width: 20px; height: 20px" />
                                <span style="font-weight: 600" v-if="item.name">{{ item.name }}</span>
                                <span style="font-weight: 600" v-else>Config #{{ index + 1 }}</span>
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn icon size="small" variant="text" @click.stop="Delete(item, index)" class="delete-icon-btn">
                                <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px" />
                              </v-btn>
                              <template #actions="{ expanded }">
                                <v-icon :icon="expanded ? 'mdi-menu-up' : 'mdi-menu-down'" color="#171717" size="32"></v-icon>
                              </template>
                            </v-expansion-panel-title>

                            <v-expansion-panel-text class="accordion-content">
                              <v-card flat class="accordion-inner-card">
                                <v-card-text>
                                  <!-- Basic Information -->
                                  <div class="section">
                                    <div class="section-header">
                                      <img :src="images.streamLineBlock" alt="streamline block" class="mr-1" style="width: 20px; height: 20px" />
                                      <span class="section-title-1">Basic Information</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Configuration Name <span style="color: red">*</span></span>
                                          <v-tooltip location="right" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>This unique name assigned to this specific set of saved model and system settings.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.name"
                                          :rules="[rules.required]"
                                          @keypress="specialCharacters($event)"
                                          @paste="specialCharactersOnPaste"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Enter Configuration Name"
                                          color="primary"
                                        >
                                        </v-text-field>
                                      </v-col>

                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Model Group</span>
                                          <v-tooltip location="right" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>Select the model group linked to this LINE account.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-autocomplete
                                          :items="DDGroupModel"
                                          item-title="name"
                                          item-value="id"
                                          v-model="item.groupModelID"
                                          clearable
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1 model-group-selector"
                                          placeholder="Select Model Group"
                                          color="primary"
                                        >
                                        </v-autocomplete>
                                      </v-col>
                                    </v-row>
                                  </div>

                                  <div class="action-divider"></div>

                                  <!-- Authentication Details -->
                                  <div class="section">
                                    <div class="section-header">
                                      <img :src="images.auth" alt="shieldkey" class="mr-1" style="width: 20px; height: 20px" />
                                      <span class="section-title-1">Authentication Details</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Channel Secret <span style="color: red">*</span></span>
                                          <v-tooltip location="right" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>Your LINE channel’s secret key.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.secret"
                                          :rules="[rules.required]"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          :type="checkSecretVisibility('linecs:' + item.secret) ? 'text' : 'password'"
                                          class="modern-field secure-field mt-1"
                                          placeholder="Channel Secret"
                                          color="primary"
                                        >
                                          <template v-slot:append-inner>
                                            <v-btn icon variant="text" size="small" @click="toggleSecretVisibility('linecs:' + item.secret, $event)">
                                              <v-icon size="16">
                                                <span class="d-flex justify-center align-center" v-if="checkSecretVisibility('linecs:' + item.secret)">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
                                                    <mask :id="'path-1-inside-1_8285_59116-secret-' + index" fill="white">
                                                      <path
                                                        d="M12.0678 8.98663C10.0001 8.98663 8.32363 10.5714 8.32363 12.5261C8.32363 14.4804 10.0001 16.0655 12.0678 16.0655C14.1356 16.0655 15.8121 14.4807 15.8121 12.5261C15.8121 10.5714 14.1356 8.98663 12.0678 8.98663ZM12.0678 14.8857C10.6915 14.8857 9.54298 13.8014 9.54298 12.5004C9.54298 11.1993 10.6628 10.1408 12.0391 10.1408C13.4157 10.1408 14.5353 11.1993 14.5353 12.5004C14.5353 13.8014 13.4445 14.8857 12.0678 14.8857ZM21.9785 12.3632C21.9713 12.3335 21.9744 12.3019 21.9651 12.2727C21.961 12.2604 21.9529 12.2533 21.9482 12.2424C21.9417 12.2256 21.9432 12.2058 21.9342 12.1896C20.1192 8.2611 16.2074 6 12.0388 6C7.87029 6 3.8802 8.25697 2.06426 12.1857C2.05646 12.2023 2.0577 12.2194 2.05144 12.2383C2.0471 12.2498 2.03805 12.2562 2.03399 12.2671C2.02432 12.2969 2.02806 12.3279 2.02213 12.358C2.01061 12.4111 2 12.4627 2 12.5164C2 12.5707 2.01061 12.6208 2.02213 12.6747C2.02837 12.7042 2.02434 12.7364 2.03401 12.7647C2.03807 12.778 2.04711 12.7836 2.05146 12.7957C2.05802 12.8119 2.05646 12.832 2.06426 12.8482C3.88051 16.7758 7.83159 19 12.0002 19C16.169 19 20.1192 16.7805 21.9348 12.852C21.9439 12.8352 21.942 12.8175 21.9488 12.7989C21.9532 12.7886 21.9616 12.7809 21.9654 12.7694C21.9751 12.7405 21.9719 12.7089 21.9788 12.6789C21.9897 12.6261 22 12.5744 22 12.5199C22 12.468 21.9897 12.4166 21.9785 12.3632ZM12.0001 17.8202C8.46466 17.8202 4.98474 16.0585 3.27489 12.517C4.96852 8.98726 8.49495 7.18009 12.0392 7.18009C15.5821 7.18009 19.0302 8.98932 20.7245 12.5208C19.0315 16.0493 15.5443 17.8202 12.0001 17.8202Z"
                                                      />
                                                    </mask>
                                                    <path
                                                      d="M12.0678 8.98663C10.0001 8.98663 8.32363 10.5714 8.32363 12.5261C8.32363 14.4804 10.0001 16.0655 12.0678 16.0655C14.1356 16.0655 15.8121 14.4807 15.8121 12.5261C15.8121 10.5714 14.1356 8.98663 12.0678 8.98663ZM12.0678 14.8857C10.6915 14.8857 9.54298 13.8014 9.54298 12.5004C9.54298 11.1993 10.6628 10.1408 12.0391 10.1408C13.4157 10.1408 14.5353 11.1993 14.5353 12.5004C14.5353 13.8014 13.4445 14.8857 12.0678 14.8857ZM21.9785 12.3632C21.9713 12.3335 21.9744 12.3019 21.9651 12.2727C21.961 12.2604 21.9529 12.2533 21.9482 12.2424C21.9417 12.2256 21.9432 12.2058 21.9342 12.1896C20.1192 8.2611 16.2074 6 12.0388 6C7.87029 6 3.8802 8.25697 2.06426 12.1857C2.05646 12.2023 2.0577 12.2194 2.05144 12.2383C2.0471 12.2498 2.03805 12.2562 2.03399 12.2671C2.02432 12.2969 2.02806 12.3279 2.02213 12.358C2.01061 12.4111 2 12.4627 2 12.5164C2 12.5707 2.01061 12.6208 2.02213 12.6747C2.02837 12.7042 2.02434 12.7364 2.03401 12.7647C2.03807 12.778 2.04711 12.7836 2.05146 12.7957C2.05802 12.8119 2.05646 12.832 2.06426 12.8482C3.88051 16.7758 7.83159 19 12.0002 19C16.169 19 20.1192 16.7805 21.9348 12.852C21.9439 12.8352 21.942 12.8175 21.9488 12.7989C21.9532 12.7886 21.9616 12.7809 21.9654 12.7694C21.9751 12.7405 21.9719 12.7089 21.9788 12.6789C21.9897 12.6261 22 12.5744 22 12.5199C22 12.468 21.9897 12.4166 21.9785 12.3632ZM12.0001 17.8202C8.46466 17.8202 4.98474 16.0585 3.27489 12.517C4.96852 8.98726 8.49495 7.18009 12.0392 7.18009C15.5821 7.18009 19.0302 8.98932 20.7245 12.5208C19.0315 16.0493 15.5443 17.8202 12.0001 17.8202Z"
                                                      fill="black"
                                                    />
                                                    <path
                                                      d="M21.9785 12.3632L23.4464 12.0545L23.4419 12.0332L23.4368 12.0119L21.9785 12.3632ZM21.9651 12.2727L23.3933 11.8142L23.3904 11.8053L21.9651 12.2727ZM21.9482 12.2424L20.5506 12.7871L20.5597 12.8105L20.5696 12.8336L21.9482 12.2424ZM21.9342 12.1896L20.5725 12.8187L20.5964 12.8705L20.6242 12.9203L21.9342 12.1896ZM2.06426 12.1857L3.42093 12.8257L3.42584 12.8151L2.06426 12.1857ZM2.05144 12.2383L3.45453 12.7687L3.46554 12.7396L3.47534 12.71L2.05144 12.2383ZM2.03399 12.2671L0.627968 11.7446L0.617017 11.774L0.607309 11.8039L2.03399 12.2671ZM2.02213 12.358L3.48799 12.6762L3.49105 12.6621L3.49383 12.648L2.02213 12.358ZM2.02213 12.6747L3.48965 12.3643L3.48904 12.3614L2.02213 12.6747ZM2.03401 12.7647L3.46852 12.3263L3.46138 12.3029L3.45348 12.2798L2.03401 12.7647ZM2.05146 12.7957L0.639956 13.3033L0.64977 13.3306L0.660632 13.3575L2.05146 12.7957ZM2.06426 12.8482L3.42573 12.2186L3.42099 12.2083L3.41609 12.1982L2.06426 12.8482ZM21.9348 12.852L20.614 12.1411L20.5923 12.1813L20.5732 12.2227L21.9348 12.852ZM21.9488 12.7989L20.5674 12.2144L20.5536 12.2471L20.5413 12.2804L21.9488 12.7989ZM21.9654 12.7694L20.5429 12.2934L20.5398 12.303L21.9654 12.7694ZM21.9788 12.6789L23.4414 13.0116L23.4447 12.9972L23.4477 12.9827L21.9788 12.6789ZM3.27489 12.517L1.92251 11.868L1.61018 12.519L1.92408 13.1691L3.27489 12.517ZM20.7245 12.5208L22.0769 13.1697L22.3882 12.5208L22.0769 11.872L20.7245 12.5208ZM12.0678 8.98663V7.48663C9.25228 7.48663 6.82363 9.66461 6.82363 12.5261H8.32363H9.82363C9.82363 11.4782 10.7479 10.4866 12.0678 10.4866V8.98663ZM8.32363 12.5261H6.82363C6.82363 15.3871 9.2522 17.5655 12.0678 17.5655V16.0655V14.5655C10.748 14.5655 9.82363 13.5737 9.82363 12.5261H8.32363ZM12.0678 16.0655V17.5655C14.8834 17.5655 17.3121 15.3875 17.3121 12.5261H15.8121H14.3121C14.3121 13.5739 13.3878 14.5655 12.0678 14.5655V16.0655ZM15.8121 12.5261H17.3121C17.3121 9.66461 14.8834 7.48663 12.0678 7.48663V8.98663V10.4866C13.3878 10.4866 14.3121 11.4782 14.3121 12.5261H15.8121ZM12.0678 14.8857V13.3857C11.4381 13.3857 11.043 12.8935 11.043 12.5004H9.54298H8.04298C8.04298 14.7094 9.94496 16.3857 12.0678 16.3857V14.8857ZM9.54298 12.5004H11.043C11.043 12.1061 11.4106 11.6408 12.0391 11.6408V10.1408V8.64076C9.915 8.64076 8.04298 10.2925 8.04298 12.5004H9.54298ZM12.0391 10.1408V11.6408C12.6678 11.6408 13.0353 12.106 13.0353 12.5004H14.5353H16.0353C16.0353 10.2927 14.1637 8.64076 12.0391 8.64076V10.1408ZM14.5353 12.5004H13.0353C13.0353 12.9375 12.6519 13.3857 12.0678 13.3857V14.8857V16.3857C14.237 16.3857 16.0353 14.6653 16.0353 12.5004H14.5353ZM21.9785 12.3632L23.4368 12.0119C23.4544 12.0854 23.4619 12.1436 23.4651 12.1717C23.4668 12.1861 23.4677 12.1967 23.4679 12.1994C23.468 12.2008 23.4681 12.2015 23.468 12.2C23.4679 12.1994 23.4676 12.1954 23.4673 12.1919C23.4663 12.1795 23.4622 12.1304 23.4533 12.071C23.4438 12.0086 23.4268 11.9186 23.3933 11.8142L21.9651 12.2727L20.5368 12.7312C20.5223 12.686 20.5117 12.6448 20.5038 12.6092C20.4959 12.5738 20.4906 12.5431 20.4869 12.519C20.4833 12.4951 20.4811 12.4758 20.4798 12.4636C20.4791 12.4574 20.4787 12.4525 20.4784 12.4492C20.4781 12.4461 20.4779 12.4439 20.4779 12.4437C20.4779 12.4435 20.4779 12.4436 20.4779 12.4442C20.478 12.4456 20.478 12.4449 20.4782 12.447C20.4783 12.4493 20.4787 12.4538 20.4792 12.4591C20.4801 12.4694 20.4817 12.4876 20.4842 12.5096C20.4867 12.532 20.4905 12.5612 20.4961 12.5952C20.5017 12.6293 20.5094 12.6696 20.5202 12.7145L21.9785 12.3632ZM21.9651 12.2727L23.3904 11.8053C23.3216 11.5955 23.2217 11.4501 23.2049 11.4249C23.2037 11.4231 23.2027 11.4216 23.2021 11.4206C23.2015 11.4198 23.2009 11.4189 23.2008 11.4188C23.2003 11.4181 23.2017 11.4201 23.2033 11.4226C23.2067 11.4276 23.2159 11.4415 23.2272 11.4598C23.2506 11.4974 23.2892 11.5635 23.3268 11.6512L21.9482 12.2424L20.5696 12.8336C20.6096 12.9267 20.651 12.9978 20.6772 13.0401C20.6901 13.0609 20.7008 13.077 20.7057 13.0844C20.7082 13.0881 20.7103 13.0913 20.7105 13.0917C20.7114 13.0929 20.7102 13.0911 20.7088 13.0891C20.6983 13.0733 20.6045 12.9375 20.5397 12.7401L21.9651 12.2727ZM21.9482 12.2424L23.3458 11.6977C23.3864 11.8019 23.4057 11.8876 23.414 11.9281C23.4183 11.949 23.421 11.965 23.4218 11.9695C23.4221 11.9717 23.4224 11.9735 23.4221 11.9716C23.422 11.9708 23.4213 11.9664 23.4204 11.9615C23.4177 11.9457 23.4065 11.8795 23.3839 11.7986C23.36 11.7132 23.3186 11.5923 23.2442 11.4589L21.9342 12.1896L20.6242 12.9203C20.5542 12.7949 20.516 12.6826 20.4946 12.606C20.4744 12.5339 20.465 12.4768 20.4638 12.47C20.4634 12.4673 20.463 12.4653 20.4633 12.4667C20.4633 12.4671 20.464 12.4712 20.4648 12.4756C20.4663 12.4846 20.4699 12.5051 20.4751 12.5306C20.4852 12.5799 20.5067 12.6744 20.5506 12.7871L21.9482 12.2424ZM21.9342 12.1896L23.2959 11.5605C21.2162 7.05912 16.7446 4.5 12.0388 4.5V6V7.5C15.6702 7.5 19.0221 9.46309 20.5725 12.8187L21.9342 12.1896ZM12.0388 6V4.5C7.34635 4.5 2.78851 7.04372 0.702669 11.5564L2.06426 12.1857L3.42584 12.8151C4.97189 9.47023 8.39422 7.5 12.0388 7.5V6ZM2.06426 12.1857L0.707627 11.5458C0.655959 11.6553 0.625297 11.7534 0.606436 11.8273C0.588845 11.8962 0.579684 11.9525 0.577553 11.9653C0.576903 11.9692 0.57631 11.9729 0.576247 11.9732C0.576041 11.9745 0.576299 11.9729 0.57666 11.9707C0.577398 11.9663 0.579607 11.9532 0.58298 11.936C0.589913 11.9006 0.603208 11.84 0.627549 11.7665L2.05144 12.2383L3.47534 12.71C3.50281 12.6271 3.5183 12.5572 3.527 12.5128C3.53126 12.4911 3.53425 12.4735 3.53572 12.4647C3.53645 12.4603 3.53707 12.4565 3.53722 12.4555C3.53752 12.4537 3.53728 12.4552 3.53699 12.4569C3.53631 12.4611 3.52869 12.5087 3.51325 12.5692C3.49655 12.6347 3.46865 12.7244 3.42089 12.8257L2.06426 12.1857ZM2.05144 12.2383L0.648362 11.7078C0.692289 11.5916 0.743271 11.5016 0.781784 11.4411C0.800541 11.4116 0.816761 11.3885 0.826919 11.3743C0.832061 11.3672 0.83624 11.3615 0.838735 11.3581C0.841029 11.355 0.842855 11.3526 0.842339 11.3533C0.842338 11.3533 0.842093 11.3536 0.841914 11.3538C0.841692 11.3541 0.841354 11.3546 0.840954 11.3551C0.840169 11.3562 0.838928 11.3578 0.837434 11.3598C0.834506 11.3638 0.82979 11.3702 0.824114 11.378C0.812947 11.3935 0.795139 11.4187 0.774703 11.4506C0.732974 11.5158 0.676072 11.6151 0.627968 11.7446L2.03399 12.2671L3.44001 12.7897C3.39394 12.9137 3.33969 13.0082 3.30093 13.0687C3.28198 13.0983 3.26574 13.1212 3.25618 13.1345C3.25131 13.1412 3.24741 13.1465 3.2453 13.1493C3.24349 13.1518 3.24184 13.1539 3.24288 13.1526C3.24319 13.1521 3.24584 13.1486 3.24896 13.1444C3.25228 13.1399 3.25729 13.1331 3.26324 13.1248C3.27503 13.1084 3.29284 13.083 3.31312 13.0511C3.33365 13.0189 3.35758 12.9786 3.38212 12.9311C3.4068 12.8834 3.43166 12.8292 3.45453 12.7687L2.05144 12.2383ZM2.03399 12.2671L0.607309 11.8039C0.572567 11.9109 0.554607 12.0045 0.544561 12.0734C0.534925 12.1396 0.531266 12.1934 0.529973 12.2128C0.529541 12.2193 0.528577 12.2348 0.528914 12.2295C0.528916 12.2294 0.529039 12.2275 0.529249 12.2245C0.529464 12.2214 0.529815 12.2166 0.530316 12.2106C0.532157 12.1886 0.537092 12.1357 0.550434 12.068L2.02213 12.358L3.49383 12.648C3.51014 12.5652 3.51683 12.4972 3.51994 12.46C3.52152 12.441 3.52252 12.4254 3.52297 12.4183C3.52316 12.4152 3.52343 12.4109 3.52343 12.4108C3.52351 12.4095 3.52346 12.4104 3.52334 12.4121C3.52313 12.4154 3.52238 12.4264 3.52096 12.4415C3.51952 12.4568 3.51714 12.479 3.51322 12.5059C3.50538 12.5598 3.49058 12.6383 3.46067 12.7304L2.03399 12.2671ZM2.02213 12.358L0.556275 12.0398C0.546977 12.0826 0.5 12.281 0.5 12.5164H2H3.5C3.5 12.5879 3.49292 12.6419 3.48884 12.668C3.4854 12.6901 3.48226 12.7026 3.48799 12.6762L2.02213 12.358ZM2 12.5164H0.5C0.5 12.7532 0.548001 12.9543 0.555223 12.9881L2.02213 12.6747L3.48904 12.3614C3.48757 12.3545 3.48668 12.3503 3.48592 12.3467C3.48558 12.3451 3.48533 12.3439 3.48517 12.3431C3.485 12.3423 3.48494 12.342 3.48494 12.342C3.48495 12.342 3.48534 12.344 3.48596 12.3474C3.48659 12.3509 3.48752 12.3562 3.48859 12.363C3.4929 12.3905 3.5 12.445 3.5 12.5164H2ZM2.02213 12.6747L0.554619 12.9852C0.538569 12.9094 0.532842 12.8499 0.530716 12.8251C0.529597 12.812 0.529024 12.8026 0.528989 12.802C0.528254 12.7902 0.529827 12.8157 0.529866 12.8163C0.530985 12.8337 0.534537 12.8894 0.54442 12.9577C0.554687 13.0287 0.574111 13.1312 0.614545 13.2496L2.03401 12.7647L3.45348 12.2798C3.48907 12.384 3.50537 12.472 3.51348 12.528C3.5176 12.5565 3.52002 12.5797 3.52144 12.5952C3.52282 12.6104 3.52354 12.6215 3.5237 12.6241C3.52379 12.6254 3.52383 12.6261 3.52373 12.6244C3.52367 12.6235 3.52343 12.6194 3.52318 12.6154C3.52267 12.6072 3.52158 12.5902 3.51981 12.5695C3.51638 12.5294 3.50882 12.4549 3.48965 12.3643L2.02213 12.6747ZM2.03401 12.7647L0.599502 13.2031C0.618657 13.2658 0.64099 13.3246 0.665363 13.3793C0.689649 13.4339 0.714691 13.4816 0.738062 13.5222C0.761168 13.5623 0.782323 13.5948 0.797914 13.6179C0.812736 13.6398 0.825125 13.6568 0.827991 13.6608C0.828831 13.6619 0.829628 13.663 0.829648 13.6631C0.829879 13.6634 0.829431 13.6628 0.828839 13.662C0.827669 13.6603 0.824284 13.6557 0.819922 13.6495C0.811279 13.6372 0.795076 13.6139 0.776034 13.5835C0.735844 13.5193 0.683653 13.4248 0.639956 13.3033L2.05146 12.7957L3.46297 12.2881C3.44044 12.2254 3.41543 12.1687 3.38995 12.118C3.36466 12.0676 3.3399 12.0252 3.31891 11.9917C3.29834 11.9589 3.28055 11.9332 3.27028 11.9187C3.2651 11.9113 3.26089 11.9055 3.2589 11.9027C3.25789 11.9014 3.25703 11.9002 3.25685 11.8999C3.25645 11.8994 3.25684 11.8999 3.25726 11.9005C3.25816 11.9017 3.26129 11.906 3.26534 11.9118C3.26951 11.9177 3.27544 11.9261 3.28242 11.9364C3.2964 11.9571 3.31599 11.9872 3.33761 12.0247C3.3595 12.0627 3.38313 12.1077 3.40613 12.1594C3.42921 12.2113 3.45038 12.267 3.46852 12.3263L2.03401 12.7647ZM2.05146 12.7957L0.660632 13.3575C0.615649 13.2461 0.59461 13.1536 0.585164 13.1071C0.580207 13.0827 0.577056 13.0638 0.575715 13.0555C0.574908 13.0505 0.573403 13.0408 0.575049 13.0514C0.57584 13.0565 0.578432 13.0733 0.582142 13.0939C0.58597 13.1152 0.591976 13.1464 0.600816 13.1834C0.618173 13.2562 0.650406 13.3692 0.712418 13.4982L2.06426 12.8482L3.41609 12.1982C3.44548 12.2593 3.46729 12.3156 3.4836 12.3641C3.49983 12.4124 3.51112 12.4546 3.51896 12.4874C3.52675 12.5201 3.53186 12.5467 3.53487 12.5635C3.53778 12.5796 3.53965 12.5919 3.53973 12.5925C3.53979 12.5928 3.53982 12.593 3.53973 12.5924C3.53967 12.5921 3.53948 12.5908 3.53927 12.5895C3.53886 12.5868 3.53802 12.5814 3.53695 12.5748C3.53488 12.562 3.53095 12.5386 3.5251 12.5098C3.51918 12.4807 3.51039 12.4415 3.49758 12.3959C3.4847 12.3501 3.46697 12.295 3.4423 12.2339L2.05146 12.7957ZM2.06426 12.8482L0.702783 13.4778C2.7899 17.9911 7.3101 20.5 12.0002 20.5V19V17.5C8.35309 17.5 4.97112 15.5604 3.42573 12.2186L2.06426 12.8482ZM12.0002 19V20.5C16.6894 20.5 21.2095 17.9967 23.2964 13.4813L21.9348 12.852L20.5732 12.2227C19.0288 15.5643 15.6486 17.5 12.0002 17.5V19ZM21.9348 12.852L23.2557 13.5629C23.3837 13.325 23.4161 13.1085 23.4209 13.0807C23.4217 13.0758 23.4224 13.0716 23.4226 13.0709C23.4228 13.0691 23.4225 13.071 23.4221 13.0734C23.4213 13.0783 23.4186 13.0938 23.4144 13.1141C23.4059 13.1558 23.3889 13.2291 23.3564 13.3174L21.9488 12.7989L20.5413 12.2804C20.5054 12.378 20.486 12.4605 20.4756 12.5112C20.4705 12.5361 20.467 12.5561 20.4654 12.5655C20.4646 12.5701 20.464 12.5742 20.4639 12.5747C20.4636 12.5762 20.464 12.5742 20.4644 12.5716C20.4657 12.5643 20.4751 12.5073 20.4952 12.4354C20.517 12.3576 20.5529 12.2545 20.614 12.1411L21.9348 12.852ZM21.9488 12.7989L23.3303 13.3834C23.2906 13.4771 23.2495 13.5467 23.2267 13.5834C23.2152 13.6019 23.2059 13.6159 23.2023 13.6212C23.2005 13.624 23.1991 13.626 23.1994 13.6256C23.1996 13.6254 23.1994 13.6256 23.1997 13.6252C23.1998 13.625 23.2001 13.6246 23.2003 13.6242C23.2009 13.6234 23.2018 13.6221 23.2029 13.6205C23.2091 13.6112 23.24 13.5655 23.2736 13.505C23.3094 13.4404 23.3538 13.3496 23.391 13.2359L21.9654 12.7694L20.5398 12.303C20.5751 12.195 20.617 12.1094 20.6501 12.0499C20.6664 12.0205 20.6809 11.9967 20.6914 11.9802C20.7015 11.9642 20.7095 11.9522 20.7118 11.9487C20.7129 11.9472 20.714 11.9455 20.7129 11.9471C20.7124 11.9478 20.7103 11.951 20.7077 11.9549C20.7026 11.9625 20.6918 11.9788 20.6788 11.9997C20.6531 12.0411 20.6092 12.1156 20.5674 12.2144L21.9488 12.7989ZM21.9654 12.7694L23.3879 13.2454C23.4238 13.138 23.4422 13.045 23.4525 12.9796C23.4623 12.917 23.4666 12.8657 23.4679 12.8504C23.4682 12.8459 23.4686 12.8418 23.4687 12.8402C23.4689 12.8379 23.4689 12.8381 23.4688 12.8387C23.4687 12.8399 23.4679 12.8491 23.4666 12.8619C23.4639 12.8868 23.4573 12.9418 23.4414 13.0116L21.9788 12.6789L20.5162 12.3461C20.4968 12.431 20.4881 12.5012 20.4838 12.5413C20.4816 12.5618 20.4801 12.5787 20.4794 12.5875C20.479 12.5919 20.4787 12.596 20.4785 12.5975C20.4783 12.5997 20.4784 12.5994 20.4784 12.5987C20.4785 12.5974 20.4793 12.5879 20.4808 12.5747C20.4822 12.5611 20.4847 12.5404 20.4887 12.515C20.4966 12.4646 20.5118 12.3864 20.5429 12.2934L21.9654 12.7694ZM21.9788 12.6789L23.4477 12.9827C23.456 12.9424 23.5 12.7488 23.5 12.5199H22H20.5C20.5 12.453 20.5063 12.4025 20.51 12.378C20.513 12.3582 20.5157 12.3467 20.5099 12.375L21.9788 12.6789ZM22 12.5199H23.5C23.5 12.2898 23.4544 12.0926 23.4464 12.0545L21.9785 12.3632L20.5106 12.672C20.5164 12.6997 20.5137 12.6889 20.5107 12.669C20.5071 12.6455 20.5 12.592 20.5 12.5199H22ZM12.0001 17.8202V16.3202C8.95345 16.3202 6.04959 14.814 4.62569 11.8648L3.27489 12.517L1.92408 13.1691C3.9199 17.3029 7.97587 19.3202 12.0001 19.3202V17.8202ZM3.27489 12.517L4.62726 13.1659C6.03634 10.2292 8.98645 8.68009 12.0392 8.68009V7.18009V5.68009C8.00344 5.68009 3.90069 7.74532 1.92251 11.868L3.27489 12.517ZM12.0392 7.18009V8.68009C15.0758 8.68009 17.9566 10.2192 19.3721 13.1696L20.7245 12.5208L22.0769 11.872C20.1039 7.75943 16.0884 5.68009 12.0392 5.68009V7.18009ZM20.7245 12.5208L19.3721 11.8719C17.9653 14.804 15.0571 16.3202 12.0001 16.3202V17.8202V19.3202C16.0316 19.3202 20.0977 17.2946 22.0769 13.1697L20.7245 12.5208Z"
                                                      fill="black"
                                                      :mask="'url(#path-1-inside-1_8285_59116-secret-' + index + ')'"
                                                    />
                                                  </svg>
                                                </span>

                                                <span class="d-flex justify-center align-center" v-else>
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
                                                    <path
                                                      d="M10.73 5.073C11.1516 5.02419 11.5756 4.99982 12 5C16.664 5 20.4 7.903 22 12C21.6126 12.9966 21.0893 13.9348 20.445 14.788M6.52 6.519C4.48 7.764 2.9 9.693 2 12C3.6 16.097 7.336 19 12 19C13.9321 19.0102 15.8292 18.484 17.48 17.48M9.88 9.88C9.6014 10.1586 9.3804 10.4893 9.22963 10.8534C9.07885 11.2174 9.00125 11.6075 9.00125 12.0015C9.00125 12.3955 9.07885 12.7856 9.22963 13.1496C9.3804 13.5137 9.6014 13.8444 9.88 14.123C10.1586 14.4016 10.4893 14.6226 10.8534 14.7734C11.2174 14.9242 11.6075 15.0018 12.0015 15.0018C12.3955 15.0018 12.7856 14.9242 13.1496 14.7734C13.5137 14.6226 13.8444 14.4016 14.123 14.123"
                                                      stroke="#171717"
                                                      stroke-width="1.5"
                                                      stroke-linecap="round"
                                                      stroke-linejoin="round"
                                                    />
                                                    <path d="M4 4L20 20" stroke="#171717" stroke-width="1.5" stroke-linecap="round" />
                                                  </svg>
                                                </span>
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                        </v-text-field>
                                      </v-col>

                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Channel Access Token <span style="color: red">*</span></span>
                                          <v-tooltip location="right" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>Token used for authentication and messaging.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.token"
                                          :rules="[rules.required]"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          :type="checkSecretVisibility('linetoken:' + item.token) ? 'text' : 'password'"
                                          class="modern-field secure-field mt-1"
                                          placeholder="Channel Access Token"
                                          color="primary"
                                        >
                                          <template v-slot:append-inner>
                                            <v-btn icon variant="text" size="small" @click="toggleSecretVisibility('linetoken:' + item.token, $event)">
                                              <span class="d-flex justify-center align-center" v-if="checkSecretVisibility('linetoken:' + item.token)">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
                                                  <mask :id="'path-1-inside-1_8285_59116-token-' + index" fill="white">
                                                    <path
                                                      d="M12.0678 8.98663C10.0001 8.98663 8.32363 10.5714 8.32363 12.5261C8.32363 14.4804 10.0001 16.0655 12.0678 16.0655C14.1356 16.0655 15.8121 14.4807 15.8121 12.5261C15.8121 10.5714 14.1356 8.98663 12.0678 8.98663ZM12.0678 14.8857C10.6915 14.8857 9.54298 13.8014 9.54298 12.5004C9.54298 11.1993 10.6628 10.1408 12.0391 10.1408C13.4157 10.1408 14.5353 11.1993 14.5353 12.5004C14.5353 13.8014 13.4445 14.8857 12.0678 14.8857ZM21.9785 12.3632C21.9713 12.3335 21.9744 12.3019 21.9651 12.2727C21.961 12.2604 21.9529 12.2533 21.9482 12.2424C21.9417 12.2256 21.9432 12.2058 21.9342 12.1896C20.1192 8.2611 16.2074 6 12.0388 6C7.87029 6 3.8802 8.25697 2.06426 12.1857C2.05646 12.2023 2.0577 12.2194 2.05144 12.2383C2.0471 12.2498 2.03805 12.2562 2.03399 12.2671C2.02432 12.2969 2.02806 12.3279 2.02213 12.358C2.01061 12.4111 2 12.4627 2 12.5164C2 12.5707 2.01061 12.6208 2.02213 12.6747C2.02837 12.7042 2.02434 12.7364 2.03401 12.7647C2.03807 12.778 2.04711 12.7836 2.05146 12.7957C2.05802 12.8119 2.05646 12.832 2.06426 12.8482C3.88051 16.7758 7.83159 19 12.0002 19C16.169 19 20.1192 16.7805 21.9348 12.852C21.9439 12.8352 21.942 12.8175 21.9488 12.7989C21.9532 12.7886 21.9616 12.7809 21.9654 12.7694C21.9751 12.7405 21.9719 12.7089 21.9788 12.6789C21.9897 12.6261 22 12.5744 22 12.5199C22 12.468 21.9897 12.4166 21.9785 12.3632ZM12.0001 17.8202C8.46466 17.8202 4.98474 16.0585 3.27489 12.517C4.96852 8.98726 8.49495 7.18009 12.0392 7.18009C15.5821 7.18009 19.0302 8.98932 20.7245 12.5208C19.0315 16.0493 15.5443 17.8202 12.0001 17.8202Z"
                                                    />
                                                  </mask>
                                                  <path
                                                    d="M12.0678 8.98663C10.0001 8.98663 8.32363 10.5714 8.32363 12.5261C8.32363 14.4804 10.0001 16.0655 12.0678 16.0655C14.1356 16.0655 15.8121 14.4807 15.8121 12.5261C15.8121 10.5714 14.1356 8.98663 12.0678 8.98663ZM12.0678 14.8857C10.6915 14.8857 9.54298 13.8014 9.54298 12.5004C9.54298 11.1993 10.6628 10.1408 12.0391 10.1408C13.4157 10.1408 14.5353 11.1993 14.5353 12.5004C14.5353 13.8014 13.4445 14.8857 12.0678 14.8857ZM21.9785 12.3632C21.9713 12.3335 21.9744 12.3019 21.9651 12.2727C21.961 12.2604 21.9529 12.2533 21.9482 12.2424C21.9417 12.2256 21.9432 12.2058 21.9342 12.1896C20.1192 8.2611 16.2074 6 12.0388 6C7.87029 6 3.8802 8.25697 2.06426 12.1857C2.05646 12.2023 2.0577 12.2194 2.05144 12.2383C2.0471 12.2498 2.03805 12.2562 2.03399 12.2671C2.02432 12.2969 2.02806 12.3279 2.02213 12.358C2.01061 12.4111 2 12.4627 2 12.5164C2 12.5707 2.01061 12.6208 2.02213 12.6747C2.02837 12.7042 2.02434 12.7364 2.03401 12.7647C2.03807 12.778 2.04711 12.7836 2.05146 12.7957C2.05802 12.8119 2.05646 12.832 2.06426 12.8482C3.88051 16.7758 7.83159 19 12.0002 19C16.169 19 20.1192 16.7805 21.9348 12.852C21.9439 12.8352 21.942 12.8175 21.9488 12.7989C21.9532 12.7886 21.9616 12.7809 21.9654 12.7694C21.9751 12.7405 21.9719 12.7089 21.9788 12.6789C21.9897 12.6261 22 12.5744 22 12.5199C22 12.468 21.9897 12.4166 21.9785 12.3632ZM12.0001 17.8202C8.46466 17.8202 4.98474 16.0585 3.27489 12.517C4.96852 8.98726 8.49495 7.18009 12.0392 7.18009C15.5821 7.18009 19.0302 8.98932 20.7245 12.5208C19.0315 16.0493 15.5443 17.8202 12.0001 17.8202Z"
                                                    fill="black"
                                                  />
                                                  <path
                                                    d="M21.9785 12.3632L23.4464 12.0545L23.4419 12.0332L23.4368 12.0119L21.9785 12.3632ZM21.9651 12.2727L23.3933 11.8142L23.3904 11.8053L21.9651 12.2727ZM21.9482 12.2424L20.5506 12.7871L20.5597 12.8105L20.5696 12.8336L21.9482 12.2424ZM21.9342 12.1896L20.5725 12.8187L20.5964 12.8705L20.6242 12.9203L21.9342 12.1896ZM2.06426 12.1857L3.42093 12.8257L3.42584 12.8151L2.06426 12.1857ZM2.05144 12.2383L3.45453 12.7687L3.46554 12.7396L3.47534 12.71L2.05144 12.2383ZM2.03399 12.2671L0.627968 11.7446L0.617017 11.774L0.607309 11.8039L2.03399 12.2671ZM2.02213 12.358L3.48799 12.6762L3.49105 12.6621L3.49383 12.648L2.02213 12.358ZM2.02213 12.6747L3.48965 12.3643L3.48904 12.3614L2.02213 12.6747ZM2.03401 12.7647L3.46852 12.3263L3.46138 12.3029L3.45348 12.2798L2.03401 12.7647ZM2.05146 12.7957L0.639956 13.3033L0.64977 13.3306L0.660632 13.3575L2.05146 12.7957ZM2.06426 12.8482L3.42573 12.2186L3.42099 12.2083L3.41609 12.1982L2.06426 12.8482ZM21.9348 12.852L20.614 12.1411L20.5923 12.1813L20.5732 12.2227L21.9348 12.852ZM21.9488 12.7989L20.5674 12.2144L20.5536 12.2471L20.5413 12.2804L21.9488 12.7989ZM21.9654 12.7694L20.5429 12.2934L20.5398 12.303L21.9654 12.7694ZM21.9788 12.6789L23.4414 13.0116L23.4447 12.9972L23.4477 12.9827L21.9788 12.6789ZM3.27489 12.517L1.92251 11.868L1.61018 12.519L1.92408 13.1691L3.27489 12.517ZM20.7245 12.5208L22.0769 13.1697L22.3882 12.5208L22.0769 11.872L20.7245 12.5208ZM12.0678 8.98663V7.48663C9.25228 7.48663 6.82363 9.66461 6.82363 12.5261H8.32363H9.82363C9.82363 11.4782 10.7479 10.4866 12.0678 10.4866V8.98663ZM8.32363 12.5261H6.82363C6.82363 15.3871 9.2522 17.5655 12.0678 17.5655V16.0655V14.5655C10.748 14.5655 9.82363 13.5737 9.82363 12.5261H8.32363ZM12.0678 16.0655V17.5655C14.8834 17.5655 17.3121 15.3875 17.3121 12.5261H15.8121H14.3121C14.3121 13.5739 13.3878 14.5655 12.0678 14.5655V16.0655ZM15.8121 12.5261H17.3121C17.3121 9.66461 14.8834 7.48663 12.0678 7.48663V8.98663V10.4866C13.3878 10.4866 14.3121 11.4782 14.3121 12.5261H15.8121ZM12.0678 14.8857V13.3857C11.4381 13.3857 11.043 12.8935 11.043 12.5004H9.54298H8.04298C8.04298 14.7094 9.94496 16.3857 12.0678 16.3857V14.8857ZM9.54298 12.5004H11.043C11.043 12.1061 11.4106 11.6408 12.0391 11.6408V10.1408V8.64076C9.915 8.64076 8.04298 10.2925 8.04298 12.5004H9.54298ZM12.0391 10.1408V11.6408C12.6678 11.6408 13.0353 12.106 13.0353 12.5004H14.5353H16.0353C16.0353 10.2927 14.1637 8.64076 12.0391 8.64076V10.1408ZM14.5353 12.5004H13.0353C13.0353 12.9375 12.6519 13.3857 12.0678 13.3857V14.8857V16.3857C14.237 16.3857 16.0353 14.6653 16.0353 12.5004H14.5353ZM21.9785 12.3632L23.4368 12.0119C23.4544 12.0854 23.4619 12.1436 23.4651 12.1717C23.4668 12.1861 23.4677 12.1967 23.4679 12.1994C23.468 12.2008 23.4681 12.2015 23.468 12.2C23.4679 12.1994 23.4676 12.1954 23.4673 12.1919C23.4663 12.1795 23.4622 12.1304 23.4533 12.071C23.4438 12.0086 23.4268 11.9186 23.3933 11.8142L21.9651 12.2727L20.5368 12.7312C20.5223 12.686 20.5117 12.6448 20.5038 12.6092C20.4959 12.5738 20.4906 12.5431 20.4869 12.519C20.4833 12.4951 20.4811 12.4758 20.4798 12.4636C20.4791 12.4574 20.4787 12.4525 20.4784 12.4492C20.4781 12.4461 20.4779 12.4439 20.4779 12.4437C20.4779 12.4435 20.4779 12.4436 20.4779 12.4442C20.478 12.4456 20.478 12.4449 20.4782 12.447C20.4783 12.4493 20.4787 12.4538 20.4792 12.4591C20.4801 12.4694 20.4817 12.4876 20.4842 12.5096C20.4867 12.532 20.4905 12.5612 20.4961 12.5952C20.5017 12.6293 20.5094 12.6696 20.5202 12.7145L21.9785 12.3632ZM21.9651 12.2727L23.3904 11.8053C23.3216 11.5955 23.2217 11.4501 23.2049 11.4249C23.2037 11.4231 23.2027 11.4216 23.2021 11.4206C23.2015 11.4198 23.2009 11.4189 23.2008 11.4188C23.2003 11.4181 23.2017 11.4201 23.2033 11.4226C23.2067 11.4276 23.2159 11.4415 23.2272 11.4598C23.2506 11.4974 23.2892 11.5635 23.3268 11.6512L21.9482 12.2424L20.5696 12.8336C20.6096 12.9267 20.651 12.9978 20.6772 13.0401C20.6901 13.0609 20.7008 13.077 20.7057 13.0844C20.7082 13.0881 20.7103 13.0913 20.7105 13.0917C20.7114 13.0929 20.7102 13.0911 20.7088 13.0891C20.6983 13.0733 20.6045 12.9375 20.5397 12.7401L21.9651 12.2727ZM21.9482 12.2424L23.3458 11.6977C23.3864 11.8019 23.4057 11.8876 23.414 11.9281C23.4183 11.949 23.421 11.965 23.4218 11.9695C23.4221 11.9717 23.4224 11.9735 23.4221 11.9716C23.422 11.9708 23.4213 11.9664 23.4204 11.9615C23.4177 11.9457 23.4065 11.8795 23.3839 11.7986C23.36 11.7132 23.3186 11.5923 23.2442 11.4589L21.9342 12.1896L20.6242 12.9203C20.5542 12.7949 20.516 12.6826 20.4946 12.606C20.4744 12.5339 20.465 12.4768 20.4638 12.47C20.4634 12.4673 20.463 12.4653 20.4633 12.4667C20.4633 12.4671 20.464 12.4712 20.4648 12.4756C20.4663 12.4846 20.4699 12.5051 20.4751 12.5306C20.4852 12.5799 20.5067 12.6744 20.5506 12.7871L21.9482 12.2424ZM21.9342 12.1896L23.2959 11.5605C21.2162 7.05912 16.7446 4.5 12.0388 4.5V6V7.5C15.6702 7.5 19.0221 9.46309 20.5725 12.8187L21.9342 12.1896ZM12.0388 6V4.5C7.34635 4.5 2.78851 7.04372 0.702669 11.5564L2.06426 12.1857L3.42584 12.8151C4.97189 9.47023 8.39422 7.5 12.0388 7.5V6ZM2.06426 12.1857L0.707627 11.5458C0.655959 11.6553 0.625297 11.7534 0.606436 11.8273C0.588845 11.8962 0.579684 11.9525 0.577553 11.9653C0.576903 11.9692 0.57631 11.9729 0.576247 11.9732C0.576041 11.9745 0.576299 11.9729 0.57666 11.9707C0.577398 11.9663 0.579607 11.9532 0.58298 11.936C0.589913 11.9006 0.603208 11.84 0.627549 11.7665L2.05144 12.2383L3.47534 12.71C3.50281 12.6271 3.5183 12.5572 3.527 12.5128C3.53126 12.4911 3.53425 12.4735 3.53572 12.4647C3.53645 12.4603 3.53707 12.4565 3.53722 12.4555C3.53752 12.4537 3.53728 12.4552 3.53699 12.4569C3.53631 12.4611 3.52869 12.5087 3.51325 12.5692C3.49655 12.6347 3.46865 12.7244 3.42089 12.8257L2.06426 12.1857ZM2.05144 12.2383L0.648362 11.7078C0.692289 11.5916 0.743271 11.5016 0.781784 11.4411C0.800541 11.4116 0.816761 11.3885 0.826919 11.3743C0.832061 11.3672 0.83624 11.3615 0.838735 11.3581C0.841029 11.355 0.842855 11.3526 0.842339 11.3533C0.842338 11.3533 0.842093 11.3536 0.841914 11.3538C0.841692 11.3541 0.841354 11.3546 0.840954 11.3551C0.840169 11.3562 0.838928 11.3578 0.837434 11.3598C0.834506 11.3638 0.82979 11.3702 0.824114 11.378C0.812947 11.3935 0.795139 11.4187 0.774703 11.4506C0.732974 11.5158 0.676072 11.6151 0.627968 11.7446L2.03399 12.2671L3.44001 12.7897C3.39394 12.9137 3.33969 13.0082 3.30093 13.0687C3.28198 13.0983 3.26574 13.1212 3.25618 13.1345C3.25131 13.1412 3.24741 13.1465 3.2453 13.1493C3.24349 13.1518 3.24184 13.1539 3.24288 13.1526C3.24319 13.1521 3.24584 13.1486 3.24896 13.1444C3.25228 13.1399 3.25729 13.1331 3.26324 13.1248C3.27503 13.1084 3.29284 13.083 3.31312 13.0511C3.33365 13.0189 3.35758 12.9786 3.38212 12.9311C3.4068 12.8834 3.43166 12.8292 3.45453 12.7687L2.05144 12.2383ZM2.03399 12.2671L0.607309 11.8039C0.572567 11.9109 0.554607 12.0045 0.544561 12.0734C0.534925 12.1396 0.531266 12.1934 0.529973 12.2128C0.529541 12.2193 0.528577 12.2348 0.528914 12.2295C0.528916 12.2294 0.529039 12.2275 0.529249 12.2245C0.529464 12.2214 0.529815 12.2166 0.530316 12.2106C0.532157 12.1886 0.537092 12.1357 0.550434 12.068L2.02213 12.358L3.49383 12.648C3.51014 12.5652 3.51683 12.4972 3.51994 12.46C3.52152 12.441 3.52252 12.4254 3.52297 12.4183C3.52316 12.4152 3.52343 12.4109 3.52343 12.4108C3.52351 12.4095 3.52346 12.4104 3.52334 12.4121C3.52313 12.4154 3.52238 12.4264 3.52096 12.4415C3.51952 12.4568 3.51714 12.479 3.51322 12.5059C3.50538 12.5598 3.49058 12.6383 3.46067 12.7304L2.03399 12.2671ZM2.02213 12.358L0.556275 12.0398C0.546977 12.0826 0.5 12.281 0.5 12.5164H2H3.5C3.5 12.5879 3.49292 12.6419 3.48884 12.668C3.4854 12.6901 3.48226 12.7026 3.48799 12.6762L2.02213 12.358ZM2 12.5164H0.5C0.5 12.7532 0.548001 12.9543 0.555223 12.9881L2.02213 12.6747L3.48904 12.3614C3.48757 12.3545 3.48668 12.3503 3.48592 12.3467C3.48558 12.3451 3.48533 12.3439 3.48517 12.3431C3.485 12.3423 3.48494 12.342 3.48494 12.342C3.48495 12.342 3.48534 12.344 3.48596 12.3474C3.48659 12.3509 3.48752 12.3562 3.48859 12.363C3.4929 12.3905 3.5 12.445 3.5 12.5164H2ZM2.02213 12.6747L0.554619 12.9852C0.538569 12.9094 0.532842 12.8499 0.530716 12.8251C0.529597 12.812 0.529024 12.8026 0.528989 12.802C0.528254 12.7902 0.529827 12.8157 0.529866 12.8163C0.530985 12.8337 0.534537 12.8894 0.54442 12.9577C0.554687 13.0287 0.574111 13.1312 0.614545 13.2496L2.03401 12.7647L3.45348 12.2798C3.48907 12.384 3.50537 12.472 3.51348 12.528C3.5176 12.5565 3.52002 12.5797 3.52144 12.5952C3.52282 12.6104 3.52354 12.6215 3.5237 12.6241C3.52379 12.6254 3.52383 12.6261 3.52373 12.6244C3.52367 12.6235 3.52343 12.6194 3.52318 12.6154C3.52267 12.6072 3.52158 12.5902 3.51981 12.5695C3.51638 12.5294 3.50882 12.4549 3.48965 12.3643L2.02213 12.6747ZM2.03401 12.7647L0.599502 13.2031C0.618657 13.2658 0.64099 13.3246 0.665363 13.3793C0.689649 13.4339 0.714691 13.4816 0.738062 13.5222C0.761168 13.5623 0.782323 13.5948 0.797914 13.6179C0.812736 13.6398 0.825125 13.6568 0.827991 13.6608C0.828831 13.6619 0.829628 13.663 0.829648 13.6631C0.829879 13.6634 0.829431 13.6628 0.828839 13.662C0.827669 13.6603 0.824284 13.6557 0.819922 13.6495C0.811279 13.6372 0.795076 13.6139 0.776034 13.5835C0.735844 13.5193 0.683653 13.4248 0.639956 13.3033L2.05146 12.7957L3.46297 12.2881C3.44044 12.2254 3.41543 12.1687 3.38995 12.118C3.36466 12.0676 3.3399 12.0252 3.31891 11.9917C3.29834 11.9589 3.28055 11.9332 3.27028 11.9187C3.2651 11.9113 3.26089 11.9055 3.2589 11.9027C3.25789 11.9014 3.25703 11.9002 3.25685 11.8999C3.25645 11.8994 3.25684 11.8999 3.25726 11.9005C3.25816 11.9017 3.26129 11.906 3.26534 11.9118C3.26951 11.9177 3.27544 11.9261 3.28242 11.9364C3.2964 11.9571 3.31599 11.9872 3.33761 12.0247C3.3595 12.0627 3.38313 12.1077 3.40613 12.1594C3.42921 12.2113 3.45038 12.267 3.46852 12.3263L2.03401 12.7647ZM2.05146 12.7957L0.660632 13.3575C0.615649 13.2461 0.59461 13.1536 0.585164 13.1071C0.580207 13.0827 0.577056 13.0638 0.575715 13.0555C0.574908 13.0505 0.573403 13.0408 0.575049 13.0514C0.57584 13.0565 0.578432 13.0733 0.582142 13.0939C0.58597 13.1152 0.591976 13.1464 0.600816 13.1834C0.618173 13.2562 0.650406 13.3692 0.712418 13.4982L2.06426 12.8482L3.41609 12.1982C3.44548 12.2593 3.46729 12.3156 3.4836 12.3641C3.49983 12.4124 3.51112 12.4546 3.51896 12.4874C3.52675 12.5201 3.53186 12.5467 3.53487 12.5635C3.53778 12.5796 3.53965 12.5919 3.53973 12.5925C3.53979 12.5928 3.53982 12.593 3.53973 12.5924C3.53967 12.5921 3.53948 12.5908 3.53927 12.5895C3.53886 12.5868 3.53802 12.5814 3.53695 12.5748C3.53488 12.562 3.53095 12.5386 3.5251 12.5098C3.51918 12.4807 3.51039 12.4415 3.49758 12.3959C3.4847 12.3501 3.46697 12.295 3.4423 12.2339L2.05146 12.7957ZM2.06426 12.8482L0.702783 13.4778C2.7899 17.9911 7.3101 20.5 12.0002 20.5V19V17.5C8.35309 17.5 4.97112 15.5604 3.42573 12.2186L2.06426 12.8482ZM12.0002 19V20.5C16.6894 20.5 21.2095 17.9967 23.2964 13.4813L21.9348 12.852L20.5732 12.2227C19.0288 15.5643 15.6486 17.5 12.0002 17.5V19ZM21.9348 12.852L23.2557 13.5629C23.3837 13.325 23.4161 13.1085 23.4209 13.0807C23.4217 13.0758 23.4224 13.0716 23.4226 13.0709C23.4228 13.0691 23.4225 13.071 23.4221 13.0734C23.4213 13.0783 23.4186 13.0938 23.4144 13.1141C23.4059 13.1558 23.3889 13.2291 23.3564 13.3174L21.9488 12.7989L20.5413 12.2804C20.5054 12.378 20.486 12.4605 20.4756 12.5112C20.4705 12.5361 20.467 12.5561 20.4654 12.5655C20.4646 12.5701 20.464 12.5742 20.4639 12.5747C20.4636 12.5762 20.464 12.5742 20.4644 12.5716C20.4657 12.5643 20.4751 12.5073 20.4952 12.4354C20.517 12.3576 20.5529 12.2545 20.614 12.1411L21.9348 12.852ZM21.9488 12.7989L23.3303 13.3834C23.2906 13.4771 23.2495 13.5467 23.2267 13.5834C23.2152 13.6019 23.2059 13.6159 23.2023 13.6212C23.2005 13.624 23.1991 13.626 23.1994 13.6256C23.1996 13.6254 23.1994 13.6256 23.1997 13.6252C23.1998 13.625 23.2001 13.6246 23.2003 13.6242C23.2009 13.6234 23.2018 13.6221 23.2029 13.6205C23.2091 13.6112 23.24 13.5655 23.2736 13.505C23.3094 13.4404 23.3538 13.3496 23.391 13.2359L21.9654 12.7694L20.5398 12.303C20.5751 12.195 20.617 12.1094 20.6501 12.0499C20.6664 12.0205 20.6809 11.9967 20.6914 11.9802C20.7015 11.9642 20.7095 11.9522 20.7118 11.9487C20.7129 11.9472 20.714 11.9455 20.7129 11.9471C20.7124 11.9478 20.7103 11.951 20.7077 11.9549C20.7026 11.9625 20.6918 11.9788 20.6788 11.9997C20.6531 12.0411 20.6092 12.1156 20.5674 12.2144L21.9488 12.7989ZM21.9654 12.7694L23.3879 13.2454C23.4238 13.138 23.4422 13.045 23.4525 12.9796C23.4623 12.917 23.4666 12.8657 23.4679 12.8504C23.4682 12.8459 23.4686 12.8418 23.4687 12.8402C23.4689 12.8379 23.4689 12.8381 23.4688 12.8387C23.4687 12.8399 23.4679 12.8491 23.4666 12.8619C23.4639 12.8868 23.4573 12.9418 23.4414 13.0116L21.9788 12.6789L20.5162 12.3461C20.4968 12.431 20.4881 12.5012 20.4838 12.5413C20.4816 12.5618 20.4801 12.5787 20.4794 12.5875C20.479 12.5919 20.4787 12.596 20.4785 12.5975C20.4783 12.5997 20.4784 12.5994 20.4784 12.5987C20.4785 12.5974 20.4793 12.5879 20.4808 12.5747C20.4822 12.5611 20.4847 12.5404 20.4887 12.515C20.4966 12.4646 20.5118 12.3864 20.5429 12.2934L21.9654 12.7694ZM21.9788 12.6789L23.4477 12.9827C23.456 12.9424 23.5 12.7488 23.5 12.5199H22H20.5C20.5 12.453 20.5063 12.4025 20.51 12.378C20.513 12.3582 20.5157 12.3467 20.5099 12.375L21.9788 12.6789ZM22 12.5199H23.5C23.5 12.2898 23.4544 12.0926 23.4464 12.0545L21.9785 12.3632L20.5106 12.672C20.5164 12.6997 20.5137 12.6889 20.5107 12.669C20.5071 12.6455 20.5 12.592 20.5 12.5199H22ZM12.0001 17.8202V16.3202C8.95345 16.3202 6.04959 14.814 4.62569 11.8648L3.27489 12.517L1.92408 13.1691C3.9199 17.3029 7.97587 19.3202 12.0001 19.3202V17.8202ZM3.27489 12.517L4.62726 13.1659C6.03634 10.2292 8.98645 8.68009 12.0392 8.68009V7.18009V5.68009C8.00344 5.68009 3.90069 7.74532 1.92251 11.868L3.27489 12.517ZM12.0392 7.18009V8.68009C15.0758 8.68009 17.9566 10.2192 19.3721 13.1696L20.7245 12.5208L22.0769 11.872C20.1039 7.75943 16.0884 5.68009 12.0392 5.68009V7.18009ZM20.7245 12.5208L19.3721 11.8719C17.9653 14.804 15.0571 16.3202 12.0001 16.3202V17.8202V19.3202C16.0316 19.3202 20.0977 17.2946 22.0769 13.1697L20.7245 12.5208Z"
                                                    fill="black"
                                                    :mask="'url(#path-1-inside-1_8285_59116-token-' + index + ')'"
                                                  />
                                                </svg>
                                              </span>

                                              <span class="d-flex justify-center align-center" v-else>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
                                                  <path
                                                    d="M10.73 5.073C11.1516 5.02419 11.5756 4.99982 12 5C16.664 5 20.4 7.903 22 12C21.6126 12.9966 21.0893 13.9348 20.445 14.788M6.52 6.519C4.48 7.764 2.9 9.693 2 12C3.6 16.097 7.336 19 12 19C13.9321 19.0102 15.8292 18.484 17.48 17.48M9.88 9.88C9.6014 10.1586 9.3804 10.4893 9.22963 10.8534C9.07885 11.2174 9.00125 11.6075 9.00125 12.0015C9.00125 12.3955 9.07885 12.7856 9.22963 13.1496C9.3804 13.5137 9.6014 13.8444 9.88 14.123C10.1586 14.4016 10.4893 14.6226 10.8534 14.7734C11.2174 14.9242 11.6075 15.0018 12.0015 15.0018C12.3955 15.0018 12.7856 14.9242 13.1496 14.7734C13.5137 14.6226 13.8444 14.4016 14.123 14.123"
                                                    stroke="#171717"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                  />
                                                  <path d="M4 4L20 20" stroke="#171717" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                              </span>
                                            </v-btn>
                                          </template>
                                        </v-text-field>
                                      </v-col>
                                    </v-row>

                                    <v-row class="mt-4">
                                      <v-col cols="4">
                                        <v-card
                                          class="option-card d-flex flex-column"
                                          :class="{ 'option-active': item.emailVerification }"
                                          :style="item.emailVerification ? 'background: #FFF2F2;' : ''"
                                          flat
                                          height="100%"
                                          min-height="90px"
                                        >
                                          <div class="d-flex justify-space-between align-start">
                                            <div class="option-header">
                                              <div class="d-flex align-center">
                                                <span style="font-weight: 600">Require Email Verification</span>
                                                <v-tooltip top max-width="300">
                                                  <template v-slot:activator="{ props: attrs, on }">
                                                    <v-icon small color="grey lighten-1" v-bind="attrs" v-on="on" class="ml-1">mdi-information-outline</v-icon>
                                                  </template>
                                                  <span>Limit access to this LINE integration by email.</span>
                                                </v-tooltip>
                                              </div>
                                              <div class="grey--text text-caption mt-1">Users must verify their email before accessing the chatbot.</div>
                                            </div>
                                            <v-switch
                                              id="llm-selection-switch-modelmanagement"
                                              v-model="item.emailVerification"
                                              :class="['publication-toggle', item.emailVerification ? 'publication-toggle--active' : 'publication-toggle--inactive']"
                                              color="primary"
                                              hide-details
                                              dense
                                              class="mt-0"
                                              inset
                                            ></v-switch>
                                          </div>
                                        </v-card>
                                      </v-col>
                                    </v-row>
                                    <div v-if="item.emailVerification">
                                      <v-row>
                                        <!-- domain -->
                                        <v-col cols="6">
                                          <v-container class="allowed-domain-container pl-0 pr-0">
                                            <!-- Top input chips area -->
                                            <v-row class="mb-2">
                                              <v-col>
                                                <div class="d-flex align-center">
                                                  <span>Allowed Domains</span>
                                                </div>
                                                <div class="allowed-domain-input-section d-flex align-center flex-wrap">
                                                  <v-combobox
                                                    v-model="item.selectedDomains"
                                                    color="#3859D0"
                                                    placeholder="example.com"
                                                    chips
                                                    multiple
                                                    hide-details
                                                    variant="outlined"
                                                    class="allowed-domain-combobox flex-grow-1 mr-4"
                                                    :class="{ customwidth: item.selectedDomains.length === 0, 'customwidth-expanded': item.selectedDomains.length > 0 }"
                                                    @update:model-value="validateDomains(item, $event)"
                                                  >
                                                    <!-- Custom chip -->
                                                    <template #chip="{ item: chipItem }">
                                                      <v-chip
                                                        :color="isValidDomain(chipItem.value) ? 'primary' : '#FFA726'"
                                                        variant="outlined"
                                                        style="border-radius: 8px"
                                                        class="allowed-domain-chip"
                                                        closable
                                                        @click:close="removeDomainChip(item, chipItem.value)"
                                                      >
                                                        {{ chipItem.value }}
                                                        <!-- <v-icon size="14" class="ml-1" v-if="!isValidDomain(chipItem.value)">mdi-alert-circle</v-icon> -->
                                                      </v-chip>
                                                    </template>

                                                    <!-- Append button -->
                                                    <template #append-inner>
                                                      <v-btn
                                                        class="allowed-domain-insert-btn text-none"
                                                        v-if="item.selectedDomains.length > 0"
                                                        style="border-radius: 16px; border: 1px solid #3859d0; background: #3859d0; color: white"
                                                        @click="insertDomains(item)"
                                                      >
                                                        <img :src="images.addtable" alt="addtotable" class="mr-2" style="width: 20px; height: 20px" />
                                                        Insert to Table
                                                      </v-btn>
                                                    </template>
                                                  </v-combobox>
                                                </div>
                                                <div v-if="item.showSuggestion" class="allowed-domain-suggestion">Try something like “example.com”</div>
                                              </v-col>
                                            </v-row>
                                            <!-- Table header -->
                                            <div class="allowed-domain-header d-flex align-center mb-2">
                                              <v-icon color="error" class="mr-2">mdi-earth</v-icon>
                                              <span class="allowed-domain-title text-h6 font-weight-bold"> Allowed Domains Table </span>
                                            </div>

                                            <!-- Search bar -->
                                            <div class="allowed-domain-search-bar d-flex align-center mb-2">
                                              <v-text-field v-model="item.searchDomains" placeholder="Search" hide-details variant="underlined" class="allowed-domain-search-field mr-2"
                                                ><template v-slot:append-inner>
                                                  <v-icon size="20" color="error">mdi-magnify</v-icon>
                                                </template></v-text-field
                                              >
                                            </div>
                                            <div v-if="getFilteredDomains(item).length === 0 && item.domains && item.domains.length > 0 && item.searchDomains" class="nodatadiv">
                                              <span class="text-grey">Searching </span> " {{ item.searchDomains }}" Domains was not found.
                                            </div>
                                            <!-- Domain table -->
                                            <v-table class="allowed-domain-table elevation-1">
                                              <thead>
                                                <tr>
                                                  <th class="allowed-domain-th text-left">No.</th>
                                                  <th class="allowed-domain-th text-left">Domain</th>
                                                  <th class="allowed-domain-th text-center">Manage</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <!-- No results message -->
                                                <!-- <tr
                                                  v-if="getFilteredDomains(item).length === 0 && item.domains && item.domains.length > 0">
                                                  <td colspan="3" class="allowed-domain-td text-center pa-4">
                                                    <span class="text-grey">No domains found for "{{ item.searchDomains
                                                      }}"</span>
                                                  </td>
                                                </tr> -->

                                                <tr v-for="(domain, index) in getFilteredDomains(item)" :key="index" class="allowed-domain-tr">
                                                  <td class="allowed-domain-td">{{ index + 1 }}</td>
                                                  <td class="allowed-domain-td">{{ domain.contactValue || domain }}</td>
                                                  <td class="allowed-domain-td text-center">
                                                    <v-btn icon variant="text" color="primary" class="allowed-domain-edit-btn" @click="editDomain(item, getOriginalDomainIndex(item, index))">
                                                      <img :src="images.edit" alt="Edit" style="width: 25px; height: 25px" />
                                                      <v-tooltip activator="parent" location="top"> Edit </v-tooltip>
                                                    </v-btn>
                                                    <v-btn icon variant="text" color="error" class="allowed-domain-delete-btn" @click="deleteDomain(item, getOriginalDomainIndex(item, index))">
                                                      <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px" />
                                                      <v-tooltip activator="parent" location="top"> Delete </v-tooltip>
                                                    </v-btn>
                                                  </td>
                                                </tr>
                                                <!-- Delete All Row - only show when there's data -->
                                                <tr v-if="getFilteredDomains(item).length > 0">
                                                  <td colspan="3" class="allowed-domain-td text-right pa-3">
                                                    <v-btn color="error" variant="outlined" rounded="lg" size="small" class="text-none" @click="deleteAllDomains(item)"> Delete All </v-btn>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </v-table>
                                          </v-container>
                                        </v-col>

                                        <!-- emails -->
                                        <v-col cols="6">
                                          <v-container class="allowed-domain-container pl-0 pr-0">
                                            <!-- Top input chips area -->
                                            <v-row class="mb-2">
                                              <v-col>
                                                <div class="d-flex align-center">
                                                  <span>Allowed Emails</span>
                                                </div>
                                                <div class="allowed-domain-input-section d-flex align-center flex-wrap">
                                                  <v-combobox
                                                    v-model="item.selectedEmails"
                                                    placeholder="example@gmail.com"
                                                    chips
                                                    multiple
                                                    hide-details
                                                    variant="outlined"
                                                    color="#3859D0"
                                                    class="allowed-domain-combobox flex-grow-1 mr-4"
                                                    :class="{ customwidth: item.selectedEmails.length === 0, 'customwidth-expanded': item.selectedEmails.length > 0 }"
                                                    @update:model-value="validateEmails(item, $event)"
                                                  >
                                                    <!-- Custom chip -->
                                                    <template #chip="{ item: chipItem }">
                                                      <v-chip
                                                        :color="isValidEmail(chipItem.value) ? 'primary' : '#FFA726'"
                                                        variant="outlined"
                                                        style="border-radius: 8px"
                                                        class="allowed-domain-chip"
                                                        closable
                                                        @click:close="removeEmailChip(item, chipItem.value)"
                                                      >
                                                        {{ chipItem.value }}
                                                        <!-- <v-icon size="14" class="ml-1"
                                                          v-if="!isValidEmail(chipItem.value)">mdi-alert-circle</v-icon> -->
                                                      </v-chip>
                                                    </template>

                                                    <!-- Append button -->
                                                    <template #append-inner>
                                                      <v-btn
                                                        class="allowed-domain-insert-btn text-none"
                                                        v-if="item.selectedEmails.length > 0"
                                                        style="border-radius: 16px; border: 1px solid #3859d0; background: #3859d0; color: white"
                                                        @click="insertEmails(item)"
                                                      >
                                                        <img :src="images.addtable" alt="addtotable" class="mr-2" style="width: 20px; height: 20px" />
                                                        Insert to Table
                                                      </v-btn>
                                                    </template>
                                                  </v-combobox>
                                                </div>
                                                <div v-if="item.showEmailSuggestion" class="allowed-domain-suggestion">Try something like “example@gmail.com”</div>
                                              </v-col>
                                            </v-row>
                                            <!-- Table header -->
                                            <div class="allowed-domain-header d-flex align-center mb-2">
                                              <img :src="images.email" alt="Mail" class="mr-2" style="width: 20px; height: 20px" />
                                              <span class="allowed-domain-title text-h6 font-weight-bold"> Allowed Emails Table </span>
                                            </div>

                                            <!-- Search bar -->
                                            <div class="allowed-domain-search-bar d-flex align-center mb-2">
                                              <v-text-field v-model="item.searchEmails" placeholder="Search" hide-details variant="underlined" class="allowed-domain-search-field mr-2"
                                                ><template v-slot:append-inner>
                                                  <v-icon size="20" color="error">mdi-magnify</v-icon>
                                                </template></v-text-field
                                              >
                                            </div>
                                            <div v-if="getFilteredEmails(item).length === 0 && item.emails && item.emails.length > 0 && item.searchEmails" class="nodatadiv">
                                              <span class="text-grey">Searching </span> " {{ item.searchEmails }}" Email was not found.
                                            </div>
                                            <!-- Domain table -->
                                            <v-table class="allowed-domain-table elevation-1">
                                              <thead>
                                                <tr>
                                                  <th class="allowed-domain-th text-left">No.</th>
                                                  <th class="allowed-domain-th text-left">Email</th>
                                                  <th class="allowed-domain-th text-center">Manage</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <!-- No results message -->
                                                <!-- <tr
                                                  v-if="getFilteredEmails(item).length === 0 && item.emails && item.emails.length > 0">
                                                  <td colspan="3" class="allowed-domain-td text-center pa-4">
                                                    <span class="text-grey">No emails found for "{{ item.searchEmails
                                                      }}"</span>
                                                  </td>
                                                </tr> -->

                                                <tr v-for="(email, index) in getFilteredEmails(item)" :key="index" class="allowed-domain-tr">
                                                  <td class="allowed-domain-td">{{ index + 1 }}</td>
                                                  <td class="allowed-domain-td">{{ email.contactValue || email }}</td>
                                                  <td class="allowed-domain-td text-center">
                                                    <v-btn icon variant="text" color="primary" class="allowed-domain-edit-btn" @click="editEmail(item, getOriginalEmailIndex(item, index))">
                                                      <img :src="images.edit" alt="Edit" style="width: 25px; height: 25px" />
                                                      <v-tooltip activator="parent" location="top"> Edit </v-tooltip>
                                                    </v-btn>
                                                    <v-btn icon variant="text" color="error" class="allowed-domain-delete-btn" @click="deleteEmail(item, getOriginalEmailIndex(item, index))">
                                                      <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px" />
                                                      <v-tooltip activator="parent" location="top"> Delete </v-tooltip>
                                                    </v-btn>
                                                  </td>
                                                </tr>
                                                <!-- Delete All Row - only show when there's data -->
                                                <tr v-if="getFilteredEmails(item).length > 0">
                                                  <td colspan="3" class="allowed-domain-td text-right pa-3">
                                                    <v-btn color="error" variant="outlined" rounded="lg" size="small" class="text-none" @click="deleteAllEmails(item)"> Delete All </v-btn>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </v-table>
                                          </v-container>
                                        </v-col>
                                      </v-row>
                                    </div>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </v-expansion-panel-text>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>

                      <!-- <div class="config-cards-container">
                        <div
                          v-for="(item, index) in setupList"
                          :key="item.createDate.toString()"
                          v-show="item.activeFlag"
                          class="config-card line-card"
                        >
                          <div class="config-card-header">
                            <div class="config-badge">
                              <v-icon small class="mr-1">mdi-cog</v-icon>
                              Config #{{ index + 1 }}
                            </div>
                            <v-btn
                              icon
                              size="small"
                              variant="text"
                              @click="Delete(item, index)"
                              class="delete-icon-btn"
                            >
                              <v-icon color="error"
                                >mdi-trash-can-outline</v-icon
                              >
                            </v-btn>
                          </div>

                          <div class="config-card-body">
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="primary"
                                  >mdi-information</v-icon
                                >
                                Basic Information
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.name"
                                    label="Configuration Name"
                                    :rules="[rules.required]"
                                    @keypress="specialCharacters($event)"
                                    @paste="specialCharactersOnPaste"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Enter configuration name"
                                    color="primary"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="primary"
                                        >mdi-tag</v-icon
                                      >
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-autocomplete
                                    :items="DDGroupModel"
                                    item-title="name"
                                    item-value="id"
                                    v-model="item.groupModelID"
                                    label="Group Model"
                                    clearable
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Select group model"
                                    color="primary"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="primary"
                                        >mdi-group</v-icon
                                      >
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </div>

                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="warning"
                                  >mdi-shield-key</v-icon
                                >
                                Authentication Details
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.secret"
                                    label="Channel Secret"
                                    :rules="[rules.required]"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    :type="
                                      checkSecretVisibility(
                                        'linecs:' + item.secret
                                      )
                                        ? 'text'
                                        : 'password'
                                    "
                                    class="modern-field secure-field"
                                    placeholder="Enter channel secret"
                                    color="primary"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="warning"
                                        >mdi-key-variant</v-icon
                                      >
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn
                                        icon
                                        variant="text"
                                        size="small"
                                        @click="
                                          toggleSecretVisibility(
                                            'linecs:' + item.secret,
                                            $event
                                          )
                                        "
                                      >
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "linecs:" + item.secret
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.token"
                                    label="Channel Token"
                                    :rules="[rules.required]"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    :type="
                                      checkSecretVisibility(
                                        'linetoken:' + item.token
                                      )
                                        ? 'text'
                                        : 'password'
                                    "
                                    class="modern-field secure-field"
                                    placeholder="Enter channel token"
                                    color="primary"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="info"
                                        >mdi-shield-key-outline</v-icon
                                      >
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn
                                        icon
                                        variant="text"
                                        size="small"
                                        @click="
                                          toggleSecretVisibility(
                                            'linetoken:' + item.token,
                                            $event
                                          )
                                        "
                                      >
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "linetoken:" + item.token
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </div>
                          </div>
                        </div>

                        <div class="add-config-card" @click="Add('line')">
                          <div class="add-card-content">
                            <v-icon size="48" color="success" class="mb-4"
                              >mdi-plus-circle</v-icon
                            >
                            <h4>Add New Configuration</h4>
                            <p>Create a new LINE bot configuration</p>
                          </div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </v-window-item>

                <!-- MS Teams Tab -->
                <v-window-item value="teams" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large teams-gradient">
                        <v-icon size="32" color="white">mdi-microsoft-teams</v-icon>
                      </div>
                      <div class="platform-details">
                        <h2>Teams Messaging API</h2>
                        <p>Configure MS Teams</p>
                      </div>
                      <div class="platform-actions" v-if="false">
                        <v-btn color="purple" variant="flat" size="default" @click="Add('ms')" class="compact-text-btn teams-btn" rounded="lg">
                          <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                          Add Config
                        </v-btn>
                      </div>
                      <!-- <div class="platform-stats">
                        <div class="stat-item">
                          <span class="stat-number">{{
                            getConfigCount("teams")
                          }}</span>
                          <span class="stat-label">Configurations</span>
                        </div>
                      </div> -->
                      <div class="platform-stats">
                        <div class="stat-item">
                          <span class="stat-label-1">Configurations: {{ getConfigCount('teams') }}</span>
                        </div>
                      </div>
                    </div>
                    <v-row justify="end" class="mb-4 mr-2">
                      <v-btn
                        color="success"
                        size="large"
                        variant="flat"
                        @click="Update"
                        :loading="dialog"
                        :disabled="dialog"
                        prepend-icon="mdi-content-save"
                        class="save-action-button-small mr-3"
                        rounded="lg"
                      >
                        <template v-slot:prepend>
                          <v-img :src="images.saveImg" width="20" height="20"></v-img>
                        </template>
                        {{ $t('save') }} Changes
                      </v-btn>
                      <v-btn color="success" variant="flat" size="default" @click="Add('ms')" rounded="lg" class="outlined-red-btn">
                        <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                        Add Configuration
                      </v-btn>
                    </v-row>
                    <!-- Teams Configurations -->
                    <div v-if="chkDataLine" class="configurations-grid">
                      <div v-if="setupListMS.filter((item) => item.activeFlag).length === 0" class="empty-state-card">
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2">mdi-microsoft-teams</v-icon>
                        </div>
                        <h3 class="noitemtitle">No Teams configurations yet</h3>
                        <p class="noitemdesc">Create your first Microsoft Teams bot configuration</p>
                        <v-btn color="error" variant="flat" size="large" @click="Add('ms')" class="mt-4" rounded="lg" style="text-transform: none; font-weight: 500; min-width: 220px; height: 48px">
                          <v-icon left size="20" class="mr-2">mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else class="config-cards-container">
                        <!-- Teams Config Cards -->
                        <v-expansion-panels variant="accordion" class="mb-4" multiple>
                          <v-expansion-panel
                            v-for="(item, index) in setupListMS"
                            :key="index"
                            v-show="item.activeFlag"
                            :class="['accordion-custom', { 'accordion-open': expandedPanel === index }]"
                            @change="onExpandChange(index)"
                          >
                            <v-expansion-panel-title class="accordion-title">
                              <div class="d-flex align-center">
                                <img :src="images.gear" alt="addtotable" class="mr-1" style="width: 20px; height: 20px" />
                                <span style="font-weight: 600" v-if="item.name">{{ item.name }}</span>
                                <span style="font-weight: 600" v-else>Config #{{ index + 1 }}</span>
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn icon size="small" variant="text" @click.stop="Delete(item, index)" class="delete-icon-btn">
                                <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px" />
                              </v-btn>
                              <template #actions="{ expanded }">
                                <v-icon :icon="expanded ? 'mdi-menu-up' : 'mdi-menu-down'" color="#171717" size="32"></v-icon>
                              </template>
                            </v-expansion-panel-title>

                            <v-expansion-panel-text class="accordion-content">
                              <v-card flat class="accordion-inner-card">
                                <v-card-text>
                                  <!-- Basic Information -->
                                  <div class="section">
                                    <div class="section-header">
                                      <v-img :src="images.basicImg" alt="Basic Information" class="mr-2" style="max-width: 20px; height: 20px"></v-img>
                                      <span class="section-title-1">Basic Information</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Configuration Name <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>The unique name for this specific Microsoft Teams integration setup, used to distinguish it from other linked Teams channels or instances.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.name"
                                          :rules="[rules.required, (v) => (v && v.length <= 100) || 'Max 100 characters']"
                                          @keypress="specialCharacters($event)"
                                          @paste="specialCharactersOnPaste"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Enter Configuration Name"
                                          color="primary"
                                        >
                                        </v-text-field>
                                      </v-col>

                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Model Group <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>A predefined category of AI models sharing similar characteristics, purpose, enabling batch selection and management.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-autocomplete
                                          :items="DDGroupModel"
                                          item-title="name"
                                          item-value="id"
                                          v-model="item.groupModelID"
                                          clearable
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Select Model Group"
                                          color="primary"
                                        >
                                        </v-autocomplete>
                                      </v-col>
                                    </v-row>
                                  </div>

                                  <div class="action-divider"></div>

                                  <!-- Teams Configuration -->
                                  <div class="section">
                                    <div class="section-header">
                                      <v-img :src="images.shieldImg" alt="Basic Information" class="mr-2" style="max-width: 20px; height: 20px"></v-img>
                                      <span class="section-title-1">Teams Configuration</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Model Shortcut <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>A short, user-friendly alias used to quickly identify and select a specific, often complex, AI model configuration within the application.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-autocomplete
                                          :items="DDModelQuickGroup"
                                          item-title="name"
                                          item-value="id"
                                          v-model="item.modelQuickGroupID"
                                          clearable
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Select Model Shortcut"
                                          color="primary"
                                        >
                                        </v-autocomplete>
                                      </v-col>

                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Shortcut Menu <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>Quick access to the most frequently used functions and features.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-autocomplete
                                          :items="DDShortcuts"
                                          item-title="name"
                                          item-value="id"
                                          v-model="item.shortcutMenuGroupID"
                                          clearable
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Select Shortcut Menu"
                                          color="primary"
                                        >
                                        </v-autocomplete>
                                      </v-col>
                                    </v-row>
                                  </div>

                                  <div class="action-divider"></div>

                                  <!-- Generated Link -->
                                  <div class="section">
                                    <div class="section-header">
                                      <v-img :src="images.chainImg" alt="Basic Information" class="mr-2" style="max-width: 20px; height: 20px"></v-img>
                                      <span class="section-title-1">Generated Link</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="12" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Integration Link <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>Enter the required endpoint address to link to the external API or service.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field v-model="setupLinkMS[index]" variant="outlined" density="comfortable" readonly hide-details="auto" class="modern-field mt-1" color="primary">
                                          <template v-slot:append-inner>
                                            <v-btn icon variant="text" size="small" @click="ClipboardAPIKey(index)">
                                              <v-icon size="16" color="grey-darken-1">mdi-content-copy</v-icon>
                                              <v-tooltip location="top" max-width="300">
                                                <span>Copy</span>
                                              </v-tooltip>
                                            </v-btn>
                                          </template>
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </v-expansion-panel-text>
                          </v-expansion-panel>
                        </v-expansion-panels>

                        <!-- <div class="add-config-card" @click="Add('ms')">
                          <div class="add-card-content">
                            <v-icon size="48" color="purple" class="mb-4"
                              >mdi-plus-circle</v-icon
                            >
                            <h4>Add New Configuration</h4>
                            <p>Create a new Teams bot configuration</p>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </v-window-item>

                <!-- Facebook Tab -->
                <v-window-item value="facebook" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large facebook-gradient">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                          <path
                            d="M18 3.375C15.1075 3.375 12.2799 4.23274 9.87479 5.83976C7.46972 7.44677 5.5952 9.73089 4.48827 12.4033C3.38134 15.0756 3.09171 18.0162 3.65602 20.8532C4.22033 23.6902 5.61323 26.2961 7.65857 28.3414C9.70391 30.3868 12.3098 31.7797 15.1468 32.344C17.9838 32.9083 20.9244 32.6187 23.5968 31.5117C26.2691 30.4048 28.5532 28.5303 30.1602 26.1252C31.7673 23.7201 32.625 20.8926 32.625 18C32.6209 14.1225 31.0788 10.4049 28.3369 7.66309C25.5951 4.92125 21.8775 3.37909 18 3.375ZM19.125 30.323V21.375H22.5C22.7984 21.375 23.0845 21.2565 23.2955 21.0455C23.5065 20.8345 23.625 20.5484 23.625 20.25C23.625 19.9516 23.5065 19.6655 23.2955 19.4545C23.0845 19.2435 22.7984 19.125 22.5 19.125H19.125V15.75C19.125 15.1533 19.3621 14.581 19.784 14.159C20.206 13.7371 20.7783 13.5 21.375 13.5H23.625C23.9234 13.5 24.2095 13.3815 24.4205 13.1705C24.6315 12.9595 24.75 12.6734 24.75 12.375C24.75 12.0766 24.6315 11.7905 24.4205 11.5795C24.2095 11.3685 23.9234 11.25 23.625 11.25H21.375C20.1815 11.25 19.0369 11.7241 18.193 12.568C17.3491 13.4119 16.875 14.5565 16.875 15.75V19.125H13.5C13.2016 19.125 12.9155 19.2435 12.7045 19.4545C12.4935 19.6655 12.375 19.9516 12.375 20.25C12.375 20.5484 12.4935 20.8345 12.7045 21.0455C12.9155 21.2565 13.2016 21.375 13.5 21.375H16.875V30.323C13.7036 30.0335 10.7659 28.5325 8.67297 26.1323C6.58001 23.7321 5.49292 20.6174 5.63782 17.4361C5.78273 14.2549 7.14847 11.2519 9.45096 9.0519C11.7534 6.8519 14.8154 5.62421 18 5.62421C21.1846 5.62421 24.2466 6.8519 26.5491 9.0519C28.8515 11.2519 30.2173 14.2549 30.3622 17.4361C30.5071 20.6174 29.42 23.7321 27.327 26.1323C25.2341 28.5325 22.2964 30.0335 19.125 30.323Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div class="platform-details">
                        <h2>Facebook Messenger</h2>
                        <p>Configure Facebook integration</p>
                      </div>
                      <div class="platform-actions" v-if="false">
                        <v-btn color="blue" variant="flat" size="default" @click="Add('facebook')" class="compact-text-btn facebook-btn" rounded="lg">
                          <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                          Add Config
                        </v-btn>
                      </div>
                      <div class="platform-stats">
                        <div class="stat-item">
                          <span class="stat-label-1">Configurations: {{ getConfigCount('facebook') }}</span>
                        </div>
                      </div>
                    </div>
                    <v-row justify="end" class="mb-4 mr-2">
                      <v-btn
                        color="success"
                        size="large"
                        variant="flat"
                        @click="Update"
                        :loading="dialog"
                        :disabled="dialog"
                        prepend-icon="mdi-content-save"
                        class="save-action-button-small mr-3"
                        rounded="lg"
                      >
                        <template v-slot:prepend>
                          <v-img :src="images.saveImg" width="20" height="20"></v-img>
                        </template>
                        {{ $t('save') }} Changes
                      </v-btn>
                      <v-btn color="success" variant="flat" size="default" @click="Add('facebook')" rounded="lg" class="outlined-red-btn">
                        <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                        Add Configuration
                      </v-btn>
                    </v-row>
                    <!-- Facebook Configurations -->
                    <div v-if="chkDataLine" class="configurations-grid">
                      <div v-if="setupListFacebook.filter((item) => item.activeFlag).length === 0" class="empty-state-card">
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2">mdi-facebook</v-icon>
                        </div>
                        <h3 class="noitemtitle">No Facebook configurations yet</h3>
                        <p class="noitemdesc">Create your first Facebook bot configuration</p>
                        <v-btn color="blue" variant="flat" size="large" @click="Add('facebook')" class="mt-4">
                          <v-icon left>mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else>
                        <v-expansion-panels variant="accordion" class="mb-4" multiple>
                          <v-expansion-panel
                            v-for="(item, index) in setupListFacebook"
                            :key="index"
                            v-show="item.activeFlag"
                            :class="['accordion-custom', { 'accordion-open': expandedPanel === index }]"
                            @change="onExpandChange(index)"
                          >
                            <v-expansion-panel-title class="accordion-title">
                              <div class="d-flex align-center">
                                <img :src="images.gear" alt="addtotable" class="mr-1" style="width: 20px; height: 20px" />
                                <span style="font-weight: 600" v-if="item.name">{{ item.name }}</span>
                                <span style="font-weight: 600" v-else>Config #{{ index + 1 }}</span>
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn icon size="small" variant="text" @click.stop="Delete(item, index)" class="delete-icon-btn">
                                <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px" />
                              </v-btn>
                              <template #actions="{ expanded }">
                                <v-icon :icon="expanded ? 'mdi-menu-up' : 'mdi-menu-down'" color="#171717" size="32"></v-icon>
                              </template>
                            </v-expansion-panel-title>

                            <v-expansion-panel-text class="accordion-content">
                              <v-card flat class="accordion-inner-card">
                                <v-card-text>
                                  <!-- Basic Information -->
                                  <div class="section">
                                    <div class="section-header">
                                      <v-img :src="images.basicImg" alt="Basic Information" class="mr-2" style="max-width: 20px; height: 20px"></v-img>
                                      <span class="section-title-1">Basic Information</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Configuration Name <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>The unique name for this specific Facebook configurations set up used for easy identification and management.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.name"
                                          :rules="[rules.required, (v) => (v && v.length <= 100) || 'Max 100 characters']"
                                          @keypress="specialCharacters($event)"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Enter Configuration Name"
                                          color="primary"
                                        >
                                        </v-text-field>
                                      </v-col>

                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Model Group <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>A predefined category of AI models sharing similar characteristics, purpose, enabling batch selection and management.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-autocomplete
                                          :items="DDGroupModel"
                                          item-title="name"
                                          item-value="id"
                                          v-model="item.groupModelID"
                                          clearable
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Select Model Group"
                                          color="primary"
                                        >
                                        </v-autocomplete>
                                      </v-col>
                                    </v-row>
                                  </div>

                                  <!-- Divider -->
                                  <div class="action-divider"></div>

                                  <!-- Authentication Details -->
                                  <div class="section">
                                    <div class="section-header">
                                      <v-img :src="images.shieldImg" alt="Basic Information" class="mr-2" style="max-width: 20px; height: 20px"></v-img>
                                      <span class="section-title-1">Authentication Details</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Facebook Verify Token <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>The secret security key required to confirm the authenticity of incoming communication from the integrated platform.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.secret"
                                          :rules="[rules.required]"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          :type="checkSecretVisibility('fbverify:' + item.secret) ? 'text' : 'password'"
                                          class="modern-field mt-1"
                                          placeholder="Enter Verify Token"
                                          color="primary"
                                        >
                                          <template v-slot:append-inner>
                                            <v-btn icon variant="text" size="small" @click="toggleSecretVisibility('fbverify:' + item.secret, $event)">
                                              <v-icon size="16">
                                                {{ checkSecretVisibility('fbverify:' + item.secret) ? 'mdi-eye' : 'mdi-eye-off' }}
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                        </v-text-field>
                                      </v-col>

                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Facebook Access Token <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>A unique time-limited credential that authorizes the system to interact with the external API on behalf of a user or application.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.token"
                                          :rules="[rules.required]"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          :type="checkSecretVisibility('fbtoken:' + item.token) ? 'text' : 'password'"
                                          class="modern-field mt-1"
                                          placeholder="Enter Access Token"
                                          color="primary"
                                        >
                                          <template v-slot:append-inner>
                                            <v-btn icon variant="text" size="small" @click="toggleSecretVisibility('fbtoken:' + item.token, $event)">
                                              <v-icon size="16">
                                                {{ checkSecretVisibility('fbtoken:' + item.token) ? 'mdi-eye' : 'mdi-eye-off' }}
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                  </div>

                                  <!-- Divider -->
                                  <div class="action-divider"></div>

                                  <!-- API Configuration -->
                                  <div class="section">
                                    <div class="section-header">
                                      <v-img :src="images.chainImg" alt="Basic Information" class="mr-2" style="max-width: 20px; height: 20px"></v-img>
                                      <span class="section-title-1">API Configuration</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>API Version</span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>Settings used to connect the system to an external API.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.apI_Version"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Enter API Version"
                                          color="primary"
                                        >
                                        </v-text-field>
                                      </v-col>

                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Page ID <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>The unique numeric identifier assigned to the Facebook Page that the chatbot will integrate with and manage messages for.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.pageID"
                                          :rules="[rules.required]"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Enter Identifier Number"
                                          color="primary"
                                        >
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </v-expansion-panel-text>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                    </div>
                  </div>
                </v-window-item>

                <!-- Instagram Tab -->
                <v-window-item value="instagram" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large instagram-gradient">
                        <v-icon size="32" color="white">mdi-instagram</v-icon>
                      </div>
                      <div class="platform-details">
                        <h2>Instagram Messaging</h2>
                        <p>Configure Instagram for direct messages</p>
                      </div>
                      <div class="platform-actions" v-if="false">
                        <v-btn color="pink" variant="flat" size="default" @click="Add('instagram')" class="compact-text-btn instagram-btn" rounded="lg">
                          <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                          Add Config
                        </v-btn>
                      </div>
                      <div class="platform-stats">
                        <div class="stat-item">
                          <span class="stat-label-1">Configurations: {{ getConfigCount('instagram') }}</span>
                        </div>
                      </div>
                    </div>
                    <v-row justify="end" class="mb-4 mr-2">
                      <v-btn
                        color="success"
                        size="large"
                        variant="flat"
                        @click="Update"
                        :loading="dialog"
                        :disabled="dialog"
                        prepend-icon="mdi-content-save"
                        class="save-action-button-small mr-3"
                        rounded="lg"
                      >
                        <template v-slot:prepend>
                          <v-img :src="images.saveImg" width="20" height="20"></v-img>
                        </template>
                        {{ $t('save') }} Changes
                      </v-btn>
                      <v-btn color="success" variant="flat" size="default" @click="Add('instagram')" rounded="lg" class="outlined-red-btn">
                        <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                        Add Configuration
                      </v-btn>
                    </v-row>
                    <!-- Instagram Configurations -->
                    <div v-if="chkDataLine" class="configurations-grid">
                      <div v-if="setupListInstagram.filter((item) => item.activeFlag).length === 0" class="empty-state-card">
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2">mdi-instagram</v-icon>
                        </div>
                        <h3 class="noitemtitle">No Instagram configurations yet</h3>
                        <p class="noitemdesc">Create your first Instagram messaging bot configuration</p>
                        <v-btn color="pink" variant="flat" size="large" @click="Add('instagram')" class="mt-4 control-btn create-btn customadd">
                          <v-icon left>mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else>
                        <v-expansion-panels variant="accordion" class="mb-4" multiple>
                          <v-expansion-panel
                            v-for="(item, index) in setupListInstagram"
                            :key="index"
                            v-show="item.activeFlag"
                            :class="['accordion-custom', { 'accordion-open': expandedPanel === index }]"
                            @change="onExpandChange(index)"
                          >
                            <v-expansion-panel-title class="accordion-title">
                              <div class="d-flex align-center">
                                <img :src="images.gear" alt="addtotable" class="mr-1" style="width: 20px; height: 20px" />
                                <span style="font-weight: 600" v-if="item.name">{{ item.name }}</span>
                                <span style="font-weight: 600" v-else>Config #{{ index + 1 }}</span>
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn icon size="small" variant="text" @click.stop="Delete(item, index)" class="delete-icon-btn">
                                <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px" />
                              </v-btn>
                              <template #actions="{ expanded }">
                                <v-icon :icon="expanded ? 'mdi-menu-up' : 'mdi-menu-down'" color="#171717" size="32"></v-icon>
                              </template>
                            </v-expansion-panel-title>

                            <v-expansion-panel-text class="accordion-content">
                              <v-card flat class="accordion-inner-card">
                                <v-card-text>
                                  <!-- Basic Information -->
                                  <div class="section">
                                    <div class="section-header">
                                      <v-img :src="images.basicImg" alt="Basic Information" class="mr-2" style="max-width: 20px; height: 20px"></v-img>
                                      <span class="section-title-1">Basic Information</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Configuration Name <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>The unique name for this specific Instagram configurations setup used for easy identification and management.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.name"
                                          :rules="[rules.required, (v) => (v && v.length <= 100) || 'Max 100 characters']"
                                          @keypress="specialCharacters($event)"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Enter Configuration Name"
                                          color="primary"
                                        >
                                        </v-text-field>
                                      </v-col>

                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Model Group <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>A predefined category of AI models sharing similar characteristics, purpose, enabling batch selection and management.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-autocomplete
                                          :items="DDGroupModel"
                                          item-title="name"
                                          item-value="id"
                                          v-model="item.groupModelID"
                                          clearable
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Select Model Group"
                                          color="primary"
                                        >
                                        </v-autocomplete>
                                      </v-col>
                                    </v-row>
                                  </div>

                                  <!-- Divider -->
                                  <div class="action-divider"></div>

                                  <!-- Authentication Details -->
                                  <div class="section">
                                    <div class="section-header">
                                      <v-img :src="images.shieldImg" alt="Basic Information" class="mr-2" style="max-width: 20px; height: 20px"></v-img>
                                      <span class="section-title-1">Authentication Details</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Instagram Verify Token <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>The secret security key required to confirm the authenticity of incoming communication from the integrated platform.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.secret"
                                          :rules="[rules.required]"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          :type="checkSecretVisibility('igverify:' + item.secret) ? 'text' : 'password'"
                                          class="modern-field mt-1"
                                          placeholder="Enter A Unique Secret String"
                                          color="primary"
                                        >
                                          <template v-slot:append-inner>
                                            <v-btn icon variant="text" size="small" @click="toggleSecretVisibility('igverify:' + item.secret, $event)">
                                              <v-icon size="16">
                                                {{ checkSecretVisibility('igverify:' + item.secret) ? 'mdi-eye' : 'mdi-eye-off' }}
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                        </v-text-field>
                                      </v-col>

                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Instagram Access Token <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>A unique time-limited credential that authorizes the system to interact with the external API on behalf of a user or application.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.token"
                                          :rules="[rules.required]"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          :type="checkSecretVisibility('igtoken:' + item.token) ? 'text' : 'password'"
                                          class="modern-field mt-1"
                                          placeholder="Enter The Confidential Token"
                                          color="primary"
                                        >
                                          <template v-slot:append-inner>
                                            <v-btn icon variant="text" size="small" @click="toggleSecretVisibility('igtoken:' + item.token, $event)">
                                              <v-icon size="16">
                                                {{ checkSecretVisibility('igtoken:' + item.token) ? 'mdi-eye' : 'mdi-eye-off' }}
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                  </div>

                                  <!-- Divider -->
                                  <div class="action-divider"></div>

                                  <!-- API Configuration -->
                                  <div class="section">
                                    <div class="section-header">
                                      <v-img :src="images.chainImg" alt="Basic Information" class="mr-2" style="max-width: 20px; height: 20px"></v-img>
                                      <span class="section-title-1">API Configuration</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>API Version <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>Settings used to connect the system to an external API.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.apI_Version"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Enter API Version e.g., 2024-05-01"
                                          color="primary"
                                        >
                                        </v-text-field>
                                      </v-col>

                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Page ID <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>The unique numeric identifier assigned to the Facebook Page that the chatbot will integrate with and manage messages for.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.pageID"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Enter Identifier Number"
                                          color="primary"
                                        >
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </v-expansion-panel-text>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                    </div>
                  </div>
                </v-window-item>

                <!-- Snippet Tab -->
                <v-window-item value="snippet" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large snippet-gradient">
                        <v-icon size="32" color="white">mdi-code-tags</v-icon>
                      </div>
                      <div class="platform-details">
                        <h2>Web Snippet Integration</h2>
                        <p>Configure web snippet for website chatbot integration</p>
                      </div>
                      <div class="platform-actions" v-if="false">
                        <v-btn color="orange" variant="flat" size="default" @click="Add('snippet')" class="compact-text-btn snippet-btn" rounded="lg">
                          <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                          Add Config
                        </v-btn>
                      </div>
                      <div class="platform-stats">
                        <div class="stat-item">
                          <span class="stat-label-1">Configurations: {{ getConfigCount('snippet') }}</span>
                        </div>
                      </div>
                    </div>
                    <v-row justify="end" class="mb-4 mr-2">
                      <v-btn
                        color="success"
                        size="large"
                        variant="flat"
                        @click="Update"
                        :loading="dialog"
                        :disabled="dialog"
                        prepend-icon="mdi-content-save"
                        class="save-action-button-small mr-3"
                        rounded="lg"
                      >
                        <template v-slot:prepend>
                          <v-img :src="images.saveImg" width="20" height="20"></v-img>
                        </template>
                        {{ $t('save') }} Changes
                      </v-btn>
                      <v-btn color="success" variant="flat" size="default" @click="Add('snippet')" rounded="lg" class="outlined-red-btn">
                        <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                        Add Configuration
                      </v-btn>
                    </v-row>
                    <!-- Snippet Configurations -->
                    <div v-if="chkDataLine" class="configurations-grid">
                      <div v-if="setupListSnippet.filter((item) => item.activeFlag).length === 0" class="empty-state-card">
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2">mdi-code-tags</v-icon>
                        </div>
                        <h3 class="noitemtitle">No Snippet configurations yet</h3>
                        <p class="noitemdesc">Create your first web snippet configuration</p>
                        <v-btn variant="flat" size="large" @click="Add('snippet')" class="mt-4 control-btn create-btn customadd">
                          <v-icon left>mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else>
                        <v-expansion-panels variant="accordion" class="mb-4" multiple>
                          <v-expansion-panel
                            v-for="(item, index) in setupListSnippet"
                            :key="index"
                            v-show="item.activeFlag"
                            :class="['accordion-custom', { 'accordion-open': expandedPanel === index }]"
                            @change="onExpandChange(index)"
                          >
                            <v-expansion-panel-title class="accordion-title">
                              <div class="d-flex align-center">
                                <img :src="images.gear" alt="addtotable" class="mr-1" style="width: 20px; height: 20px" />
                                <span style="font-weight: 600" v-if="item.name">{{ item.name }}</span>
                                <span style="font-weight: 600" v-else>Config #{{ index + 1 }}</span>
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn icon size="small" variant="text" @click.stop="Delete(item, index)" class="delete-icon-btn">
                                <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px" />
                              </v-btn>
                              <template #actions="{ expanded }">
                                <v-icon :icon="expanded ? 'mdi-menu-up' : 'mdi-menu-down'" color="#171717" size="32"></v-icon>
                              </template>
                            </v-expansion-panel-title>

                            <v-expansion-panel-text class="accordion-content">
                              <v-card flat class="accordion-inner-card">
                                <v-card-text>
                                  <!-- Basic Information -->
                                  <div class="section">
                                    <div class="section-header">
                                      <v-img :src="images.basicImg" alt="Basic Information" class="mr-2" style="max-width: 20px; height: 20px"></v-img>
                                      <span class="section-title-1">Basic Information</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Domain Name <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>Enter the primary web address used to access this application or service.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.name"
                                          :rules="[rules.required, (v) => (v && v.length <= 100) || 'Max 100 characters']"
                                          @keypress="specialCharactersDomain($event)"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Enter Domain Name"
                                          color="primary"
                                        >
                                        </v-text-field>
                                      </v-col>

                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Model Display <span style="color: red">*</span></span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>Manages the visual format and labeling used to show the active model's identity.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-autocomplete
                                          :items="listDDModel"
                                          item-title="name"
                                          item-value="modelDisplayID"
                                          v-model="item.modelDisplayID"
                                          required
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Select Model Display"
                                          color="primary"
                                        >
                                        </v-autocomplete>
                                      </v-col>
                                    </v-row>
                                  </div>

                                  <!-- Divider -->
                                  <div class="action-divider"></div>

                                  <!-- Configuration Details -->
                                  <div class="section">
                                    <div class="section-header">
                                      <v-img :src="images.shieldImg" alt="Configuration" class="mr-2" style="max-width: 20px; height: 20px"></v-img>
                                      <span class="section-title-1">Configuration Details</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Token</span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>An encrypted string used as a security key to authenticate the system and grant temporary access to specific external resources.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.token"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Enter Token (optional)"
                                          color="primary"
                                        >
                                        </v-text-field>
                                      </v-col>

                                      <v-col cols="6" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>User Default</span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span
                                              >The baseline configuration, including roles, permissions and settings, that is automatically applied to any new user upon creation or first login.</span
                                            >
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.lineUserID"
                                          variant="outlined"
                                          density="comfortable"
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Enter Default User ID"
                                          color="primary"
                                        >
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                  </div>

                                  <!-- Divider -->
                                  <div class="action-divider"></div>

                                  <!-- Generated Resources -->
                                  <div class="section">
                                    <div class="section-header">
                                      <v-img :src="images.chainImg" alt="Generated Resources" class="mr-2" style="max-width: 20px; height: 20px"></v-img>
                                      <span class="section-title-1">Generated Resources</span>
                                    </div>

                                    <v-row class="mt-3" dense>
                                      <v-col cols="12" class="col-label-input">
                                        <div class="d-flex align-center">
                                          <span>Integration Link</span>
                                          <v-tooltip location="top" max-width="300">
                                            <template v-slot:activator="{ props }">
                                              <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>The specific URL or connection string (endpoint) required to establish communication and data exchange with the external application.</span>
                                          </v-tooltip>
                                        </div>
                                        <v-text-field
                                          v-model="item.link"
                                          variant="outlined"
                                          density="comfortable"
                                          readonly
                                          hide-details="auto"
                                          class="modern-field mt-1"
                                          placeholder="Generated Integration Link"
                                          color="primary"
                                        >
                                          <template v-slot:append-inner>
                                            <v-btn icon variant="text" size="small" @click="ClipboardScriptSnippet(index)">
                                              <v-icon size="16" color="grey">mdi-content-copy</v-icon>
                                              <v-tooltip activator="parent" location="top"> Copy </v-tooltip>
                                            </v-btn>
                                          </template>
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </v-expansion-panel-text>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                    </div>
                  </div>
                </v-window-item>
              </v-window>
            </div>
          </v-container>
        </div>
      </div>
    </v-container>

    <!-- Loading Overlay -->
    <v-overlay :value="dialog" color="primary" opacity="0.8">
      <div class="text-center">
        <v-progress-circular indeterminate size="64" color="white" width="4"></v-progress-circular>
        <p class="white--text mt-4 subtitle-1">Loading...</p>
      </div>
    </v-overlay>

    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title" v-if="deleteType === 'domain'">Delete Domain</span>
          <span class="delete-dialog-title" v-else-if="deleteType === 'email'">Delete Email</span>
          <span class="delete-dialog-title" v-else-if="deleteType === 'domain-all'">Delete All Domains</span>
          <span class="delete-dialog-title" v-else-if="deleteType === 'email-all'">Delete All Emails</span>
          <span class="delete-dialog-title" v-else>Delete</span>
          <v-btn icon variant="text" size="small" class="delete-close-icon" @click="cancelDelete">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteType === 'domain'"> Are you sure you want to delete this domain? This action cannot be undone. </span>
          <span v-else-if="deleteType === 'email'"> Are you sure you want to delete this email? This action cannot be undone. </span>
          <span v-else-if="deleteType === 'domain-all'"> Are you sure you want to delete all domains from the list? This action cannot be undone. </span>
          <span v-else-if="deleteType === 'email-all'"> Are you sure you want to delete all emails from the list? This action cannot be undone. </span>
          <span v-else> Are you sure you want to delete this item? This action cannot be undone. </span>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn class="delete-cancel-btn" @click="cancelDelete"> Cancel </v-btn>
          <v-btn class="delete-confirm-btn" @click="confirmDelete">
            <v-icon left size="18">mdi-trash-can-outline</v-icon>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_delete_Config" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">Delete Confirmation</span>
          <v-btn icon variant="text" size="small" class="delete-close-icon" @click="cancelDeleteConfig">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span> Do you want to confirm deletion of this Config? This action cannot be undone. </span>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn class="delete-cancel-btn" @click="cancelDeleteConfig"> Cancel </v-btn>
          <v-btn class="delete-confirm-btn" @click="confirmDeleteConfig">
            <Heroicons_TrashSolid />
            <span class="ml-1">Delete</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Custom Edit Dialog -->
    <v-dialog v-model="dialog_edit" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">Edit {{ editType === 'domain' ? 'Domain' : 'Email' }}</span>
          <v-btn icon variant="text" size="small" class="delete-close-icon" @click="cancelEdit">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <!-- Domain Input Field -->
          <v-text-field
            v-if="editType === 'domain'"
            v-model="editValue"
            label="Domain"
            placeholder="Enter domain (e.g., example.com)"
            :rules="[rules.required, validateDomainRule]"
            variant="outlined"
            density="comfortable"
            hide-details="auto"
            class="modern-field"
            color="primary"
            @keydown.enter="confirmEdit"
          >
            <template v-slot:prepend-inner>
              <v-icon size="20" color="error">mdi-earth</v-icon>
            </template>
          </v-text-field>

          <!-- Email Input Field -->
          <v-text-field
            v-if="editType === 'email'"
            v-model="editValue"
            label="Email"
            placeholder="Enter email (e.g., user@example.com)"
            :rules="[rules.required, validateEmailRule]"
            variant="outlined"
            density="comfortable"
            hide-details="auto"
            class="modern-field"
            color="primary"
            @keydown.enter="confirmEdit"
          >
            <template v-slot:prepend-inner>
              <v-icon size="20" color="#dc3545">mdi-email</v-icon>
            </template>
          </v-text-field>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn class="delete-cancel-btn" @click="cancelEdit"> Cancel </v-btn>
          <v-btn class="delete-confirm-btn" @click="confirmEdit" :disabled="!isEditValueValid">
            <v-icon left size="18">mdi-content-save</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Warning Dialog -->
    <v-dialog v-model="dialog_warning" max-width="600px" persistent>
      <v-card class="warning-dialog-card">
        <div class="warning-dialog-header">
          <span class="warning-dialog-title">Incomplete Information !</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="warning-close-icon"
            @click="dialog_warning = false"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span style="font-weight: 400;">
            Some required information is needed. Please fill this first.
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="reprocess-confirm-btn"
            @click="dialog_warning = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LineIcon from '@/components/icons/LineIcon.vue';
import Heroicons_TrashSolid from '@/components/icons/Heroicons_TrashSolid.vue';
import TeamIcon from '@/components/icons/TeamIcon.vue';
import FacebookIcon from '@/components/icons/FacebookIcon.vue';
import InstagramIcon from '@/components/icons/InstagramIcon.vue';
import SnippetIcon from '@/components/icons/SnippetIcon.vue';

// import checkPermissionFour from "@/api/function.js";
import LogTrace from '@/api/function.js';
import { mask } from 'vue-the-mask';
import editImg from '@/assets/Icons/Edit.png';
import deleteImg from '@/assets/Icons/Delete.png';
import AuthImg from '@/assets/Icons/Authentication Details Icon.svg';
import StreamLineBlock from '@/assets/Icons/streamline-block_basic-ui-link.svg';
import EarthImg from '@/assets/Icons/EarthDomain.png';
import EmailImg from '@/assets/Icons/EmailTable.png';
import Addtable from '@/assets/Icons/AddTable.svg';
import Gear from '@/assets/Icons/ConfigGear.svg';
import saveImg from '@/assets/Icons/basil_save-solid.svg';
import basicImg from '@/assets/images/basicinfo.png';
import shieldImg from '@/assets/images/shield.png';
import chainImg from '@/assets/images/chain.png';
export default {
  name: 'SetupSocial',
  inject: ['flagNav', 'FontColorTitle', 'SubNavbarBackGround'],
  mixins: [LogTrace],
  components: {
    LineIcon,
    Heroicons_TrashSolid,
    TeamIcon,
    FacebookIcon,
    InstagramIcon,
    SnippetIcon,
  },
  directives: {
    mask,
  },
  data: () => ({
    mask: '##########',
    showStickySaveButton: false,
    scrollThreshold: 300,
    selectedTab: 'line',
    platformConfig: [
      {
        key: 'line',
        name: 'Line',
        icon: 'LineIcon',
        chipColor: '#2CCF54',
        gradient: 'line-gradient',
      },
      {
        key: 'teams',
        name: 'Teams',
        icon: 'TeamIcon',
        chipColor: '#4D55BD',
        gradient: 'teams-gradient',
      },
      {
        key: 'facebook',
        name: 'Facebook',
        icon: 'FacebookIcon',
        chipColor: 'blue',
        gradient: 'facebook-gradient',
      },
      {
        key: 'instagram',
        name: 'Instagram',
        icon: 'mdi-instagram',
        chipColor: 'pink',
        gradient: 'instagram-gradient',
      },
      {
        key: 'snippet',
        name: 'Snippet',
        icon: 'SnippetIcon',
        chipColor: 'orange',
        gradient: 'snippet-gradient',
      },
    ],
    headers: [],
    items: [],
    panel: [0],
    show1: false,
    formHasErrors: false,
    showSecretKey: [],
    expandedPlatforms: {
      line: true,
      teams: false,
      facebook: false,
      instagram: false,
      snippet: false,
    },
    permission: {
      add: true,
      edit: true,
      delete: true,
    },
    mailcheck: false,
    phonecheck: false,
    chkDataLine: false,

    DDModelQuickGroup: [],

    DDGroupModel: [],
    DDShortcuts: [],
    numberRules: [(v) => !!v || 'Input is required!'],
    rules: {
      required: (value) => !!value || 'Required.',
    },
    Email: null,
    gg: null,
    UserType: null,
    dialog: false,
    edit: {
      id: null,
      key: null,
      value: null,
    },
    user: {
      id: null,
      key: null,
      value: null,
    },

    Editdialog: false,
    Adddialog: false,
    isSearch: false,
    searchname: '',
    email: '',
    totalTable: 0,
    itemsPerPage: 10,
    options: {},
    today: null,
    setupListGeneral: [],
    setupGeneral: {
      azureOpenAI_URL: null,
      azureOpenAI_APIKey: null,
      azureStorageConnection: null,
      azureContainer: null,
      languageTranslatorKey: null,
      languageTranslatorLocation: null,
      languageKey: null,
      languageEndpoint: null,
      channelSecretInternal: null,
      channelTokenInternal: null,
      emailHost: null,
      hostName: null,
      password: null,
      openAIAPIKey: null,
      openAIUrl: null,
      speechToTextKey: null,
      speechToTextRegion: null,
      speechToTextLanguage: null,
      pathFFMpeg: null,
      pathFFMpegLocal: null,
      autoStream: null,
    },
    setupList: [],
    setupListMS: [],
    setupListSnippet: [],
    setupListFacebook: [],
    setupListInstagram: [],
    setupLinkMS: [],
    setup: {
      azureOpenAI_URL: null,
      azureOpenAI_APIKey: null,
      azureStorageConnection: null,
      azureContainer: null,
      languageTranslatorKey: null,
      languageTranslatorLocation: null,
      languageKey: null,
      languageEndpoint: null,
      channelSecretInternal: null,
      channelTokenInternal: null,
      emailHost: null,
      hostName: null,
      password: null,
      openAIAPIKey: null,
      openAIUrl: null,
    },
    secretKey: '01234567890123456789012345678901',
    specialCharacter: /[!@#$%^&*(),.?":{}|<>+`~ ]/,
    specialCharacterDomain: /[!@#$%^&*(),?":{}|<>+`~ ]/,
    images: {
      edit: editImg,
      delete: deleteImg,
      auth: AuthImg,
      earth: EarthImg,
      email: EmailImg,
      addtable: Addtable,
      gear: Gear,
      saveImg: saveImg,
      basicImg: basicImg,
      shieldImg: shieldImg,
      chainImg: chainImg,
      streamLineBlock: StreamLineBlock,
    },
    listDDModel: [],
    showSuggestion: false,
    search: '',
    expandedPanel: null,
    dialog_delete: false,
    dialog_delete_Config: false,
    deleteItem: null,
    deleteType: '', // 'domain', 'email', 'domain-all', 'email-all'
    deleteIndex: -1,
    currentEditingItem: null,
    // Edit dialog properties
    dialog_edit: false,
    editItem: null,
    editType: '', // 'domain', 'email'
    editIndex: -1,
    editValue: '',
    currentEditingConfig: null,
    dialog_warning: false,

  }),
  watch: {},
  mounted() {
    this.GetDate();
    this.Get();
    this.GetModel();

    const scroller = document.querySelector('.v-main__scroller') || window;
    scroller.addEventListener('scroll', this.handleScroll, true);
    this._scrollContainer = scroller;
  },
  unmounted() {
    // ลบ listener ออกจาก container ที่แท้จริง
    if (this._scrollContainer) {
      this._scrollContainer.removeEventListener('scroll', this.handleScroll, true);
    }
  },
  computed: {
    form() {
      return {
        id: this.user.id,
        key: this.user.key,
        value: this.user.value,
      };
    },

    isEditValueValid() {
      if (!this.editValue.trim()) return false;

      if (this.editType === 'domain') {
        return this.isValidDomain(this.editValue.trim());
      } else if (this.editType === 'email') {
        return this.isValidEmail(this.editValue.trim());
      }

      return false;
    },

    validateDomainRule() {
      return (value) => {
        if (!value) return 'Domain is required';
        return this.isValidDomain(value) || 'Please enter a valid domain (e.g., example.com)';
      };
    },

    validateEmailRule() {
      return (value) => {
        if (!value) return 'Email is required';
        return this.isValidEmail(value) || 'Please enter a valid email address';
      };
    },
  },

  methods: {
    handleScroll(event) {
      const openAutocomplete = document.querySelector('.v-overlay--active .v-list');
      if (openAutocomplete) {
        return;
      }
      const target = event.target;
      if (target.closest('.v-navigation-drawer') || target.closest('.v-app-bar') || target.closest('.v-toolbar')) {
        return;
      }
      const { scrollTop } = event.target;
      if (scrollTop >= this.scrollThreshold) {
        this.showStickySaveButton = true;
      } else {
        this.showStickySaveButton = false;
      }
    },
    toggleSecretVisibility(key, event) {
      event.preventDefault();
      event.stopPropagation();
      const inputElement = event.target.closest('.v-field').querySelector('input');
      if (inputElement) {
        inputElement.blur();
      }

      if (this.showSecretKey.includes(key)) {
        this.showSecretKey.splice(this.showSecretKey.indexOf(key), 1);
      } else {
        this.showSecretKey.push(key);
      }
    },
    checkSecretVisibility(key) {
      return this.showSecretKey.includes(key);
    },
    toggleExpansion(platform) {
      this.expandedPlatforms[platform] = !this.expandedPlatforms[platform];
    },
    getConfigCount(platform) {
      switch (platform) {
        case 'line':
          return this.setupList.filter((item) => item.activeFlag).length;
        case 'teams':
          return this.setupListMS.filter((item) => item.activeFlag).length;
        case 'facebook':
          return this.setupListFacebook.filter((item) => item.activeFlag).length;
        case 'instagram':
          return this.setupListInstagram.filter((item) => item.activeFlag).length;
        case 'snippet':
          return this.setupListSnippet.filter((item) => item.activeFlag).length;
        default:
          return 0;
      }
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    Get() {
      try {
        let self = this;
        self.dialog = true;
        self.$call.GetOverviewSocial(
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let data = dataResponse.data;
              // DEBUG: Log the raw data to see what's returned

              self.setupList = data.filter((e) => e.typeSocial == 'line');
              self.setupListMS = data.filter((e) => e.typeSocial == 'ms');
              self.setupListSnippet = data.filter((e) => e.typeSocial == 'snippet');
              self.setupListFacebook = data.filter((e) => e.typeSocial == 'facebook');
              self.setupListInstagram = data.filter((e) => e.typeSocial == 'instagram');
              self.setupLinkMS = [];
              self.setupListMS.forEach((element) => {
                var temp = element.name.split('`');
                element.name = temp[0];
                self.setupLinkMS.push(temp[1]);
              });
              self.setupListSnippet.map((el) => {
                let temp = el.name.split('`');
                el.name = temp[0];
                el.link = temp[1];
                return {
                  ...el,
                };
              });

              // Process verified contacts for domains and emails on each split array
              self.processVerifiedContacts(self.setupList);
              self.processVerifiedContacts(self.setupListMS);
              self.processVerifiedContacts(self.setupListSnippet);
              self.processVerifiedContacts(self.setupListFacebook);
              self.processVerifiedContacts(self.setupListInstagram);
            }
            self.dialog = false;
            self.isSearch = false;
            self.chkDataLine = true;
            self.GetDDGroupModel();
            self.GetDDShortcutMenu();
            self.GetDDModelQuickGroup();
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            self.chkDataLine = true;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'Get');
      }
    },
    GetGeneral() {
      try {
        let self = this;
        self.$call.GetSetupOverview(
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.setupListGeneral = dataResponse.data;
              self.MapSetupList(self.setupListGeneral, false);
            }
            self.dialog = false;
            self.isSearch = false;
            self.Get();
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'Get');
      }
    },
    GetDDGroupModel() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDGroupModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGroupModel = dataResponse.data;
          } else {
            self.DDGroupModel = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetDDShortcutMenu() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDShortcutMenu(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDShortcuts = dataResponse.data;
          } else {
            self.DDShortcuts = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetDDModelQuickGroup() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDModelQuickGroup(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDModelQuickGroup = dataResponse.data;
          } else {
            self.DDModelQuickGroup = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    MapSetupList(source, mapForSave) {
      let self = this;
      source.forEach((element) => {
        switch (element.key) {
          case 'ChannelSecret_Internal':
            element.value = mapForSave ? self.setupGeneral.channelSecretInternal : element.value;
            self.setupGeneral.channelSecretInternal = element.value;
            break;
          case 'ChannelToken_Internal':
            element.value = mapForSave ? self.setupGeneral.channelTokenInternal : element.value;
            self.setupGeneral.channelTokenInternal = element.value;
            break;

          default:
            break;
        }
      });
    },
    EditUser(temp) {
      let self = this;
      self.edit.id = temp.id;
      self.edit.key = temp.key;
      self.edit.value = temp.value;

      self.Editdialog = true;
    },
    validateNameLength() {
      let self = this;
      const lists = [self.setupList, self.setupListMS, self.setupListSnippet, self.setupListFacebook, self.setupListInstagram];
      for (const list of lists) {
        for (const item of list) {
          if (item.name && item.name.length > 100) {
            return false;
          }
        }
      }
      return true;
    },
    // Separate basic field validation from email verification validation
    ValidateBasicFields(data) {
      for (const element of data) {
        let temp = element;
        if (temp.activeFlag == true) {
          if (
            temp.name == null ||
            temp.name == '' ||
            (temp.secret == null && temp.typeSocial == 'line') ||
            (temp.secret == '' && temp.typeSocial == 'line') ||
            (temp.token == null && temp.typeSocial == 'line') ||
            (temp.token == '' && temp.typeSocial == 'line') ||
            (temp.modelDisplayID == null && temp.typeSocial == 'snippet') ||
            (temp.secret == null && temp.typeSocial == 'facebook') ||
            (temp.secret == '' && temp.typeSocial == 'facebook') ||
            (temp.token == null && temp.typeSocial == 'facebook') ||
            (temp.token == '' && temp.typeSocial == 'facebook') ||
            (temp.pageID == null && temp.typeSocial == 'facebook') ||
            (temp.pageID == '' && temp.typeSocial == 'facebook') ||
            (temp.secret == null && temp.typeSocial == 'instagram') ||
            (temp.secret == '' && temp.typeSocial == 'instagram') ||
            (temp.token == null && temp.typeSocial == 'instagram') ||
            (temp.token == '' && temp.typeSocial == 'instagram') ||
            (temp.pageID == null && temp.typeSocial == 'instagram') ||
            (temp.pageID == '' && temp.typeSocial == 'instagram')
          ) {
            return false;
          }
        }
      }
      return true;
    },

    // Comprehensive email verification validation for all platforms
    ValidateAllEmailVerification() {
      const allLists = [
        { name: 'LINE', data: this.setupList },
        { name: 'Teams', data: this.setupListMS },
        { name: 'Snippet', data: this.setupListSnippet },
        { name: 'Facebook', data: this.setupListFacebook },
        { name: 'Instagram', data: this.setupListInstagram },
      ];

      for (const list of allLists) {
        for (let i = 0; i < list.data.length; i++) {
          const item = list.data[i];
          if (item.activeFlag && item.emailVerification) {
            if (!this.ValidateEmailVerificationContacts(item)) {
              const configName = item.name || `Configuration #${i + 1}`;
              return {
                isValid: false,
                message: `${list.name} "${configName}": Email verification is enabled but no domains or emails are configured. Please add at least one domain or email to the allowed list.`,
              };
            }
          }
        }
      }

      return { isValid: true };
    },

    // Check if email verification contacts are valid
    ValidateEmailVerificationContacts(item) {
      // Get active domains and emails (exclude those marked as inactive)
      const activeDomains = (item.domains || []).filter((domain) => domain.activeFlag !== false);
      const activeEmails = (item.emails || []).filter((email) => email.activeFlag !== false);

      // Must have at least one domain OR one email
      return activeDomains.length > 0 || activeEmails.length > 0;
    },
    Update() {
      try {
        let self = this;
        self.dialog = true;

        if (!this.validateNameLength()) {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: 'Name must be less than 100 characters',
            showConfirmButton: false,
            timer: 2000,
          });
          self.dialog = false;
          return;
        }

        // Check basic validation first
        const basicValidationResults = {
          line: self.ValidateBasicFields(self.setupList),
          teams: self.ValidateBasicFields(self.setupListMS),
          snippet: self.ValidateBasicFields(self.setupListSnippet),
          facebook: self.ValidateBasicFields(self.setupListFacebook),
          instagram: self.ValidateBasicFields(self.setupListInstagram),
        };

        const failedBasicValidation = Object.keys(basicValidationResults).find((key) => !basicValidationResults[key]);
        if (failedBasicValidation) {
          self.dialog_warning = true;
          self.dialog = false;
          return;
        }

        // Check email verification validation
        const emailVerificationResult = self.ValidateAllEmailVerification();
        if (!emailVerificationResult.isValid) {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: emailVerificationResult.message,
            showConfirmButton: false,
            timer: 3000,
          });
          self.dialog = false;
          return;
        }

        if (!self.ValidateSpecialCharacters(self.setupListMS)) {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningSpecialCharacters'),
            showConfirmButton: false,
            timer: 2000,
          });
          self.dialog = false;
          return;
        }

        // CREATE A COPY FOR API CALL - DON'T MODIFY ORIGINAL ARRAYS
        let allSetupItems = [...self.setupList, ...self.setupListMS, ...self.setupListSnippet, ...self.setupListFacebook, ...self.setupListInstagram];

        // Normalize and add verified contacts to each item
        allSetupItems = allSetupItems.map((item) => {
          const normalizedItem = self.normalizeItemProperties(item);

          if (normalizedItem.emailVerification) {
            normalizedItem.verifiedContacts = self.buildVerifiedContacts(normalizedItem);
          }
          return normalizedItem;
        });

        self.$call.UpdateSocial(
          allSetupItems,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = '✔ ' + dataResponse.message + ' Saved';
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title',
                },
              });
              self.GetGeneral();
            } else if (dataResponse.status == 3) {
              self.$swal.fire({
                icon: 'warning',
                title: self.$t('warning'),
                text: self.$t('warningDuplicateDomain'),
                showConfirmButton: false,
                timer: 2000,
              });
              self.dialog = false;
            } else {
              self.dialog = false;
            }
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'UpdateUser');
      }
    },
    UpdateLineGeneral() {
      try {
        let self = this;
        self.dialog = true;
        self.MapSetupList(self.setupListGeneral, true);
        self.$call.GetSetupUpdate(
          self.setupListGeneral,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = '✔ ' + dataResponse.message;
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title',
                },
              });
              // self.$swal.fire({
              //   icon: "success",
              //   title: dataResponse.message,
              //   showConfirmButton: false,
              //   timer: 1500,
              // });
              self.GetGeneral();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'UpdateUser');
      }
    },
    Add(type) {
      let self = this;
      let temp = {
        socialID: 0,
        name: null,
        secret: null,
        token: null,
        typeSocial: type,
        groupModelID: null,
        createDate: new Date(),
        createBy: null,
        activeFlag: true,
        modelDisplayID: null,
        // Initialize domain/email verification properties
        emailVerification: false,
        domains: [],
        emails: [],
        selectedDomains: [],
        selectedEmails: [],
        showSuggestion: false,
        showEmailSuggestion: false,
        searchDomains: '',
        searchEmails: '',
      };
      if (type == 'line') {
        self.setupList.push(temp);
      } else if (type == 'ms') {
        temp = {
          socialID: 0,
          name: null,
          secret: null,
          token: null,
          typeSocial: type,
          groupModelID: null,
          modelQuickGroupID: null,
          createDate: new Date(),
          createBy: null,
          activeFlag: true,
          modelDisplayID: null,
          shortcutMenuGroupID: null,
        };

        self.setupListMS.push(temp);
      } else if (type == 'snippet') {
        temp = {
          socialID: 0,
          name: null,
          secret: null,
          token: null,
          typeSocial: type,
          groupModelID: null,
          modelQuickGroupID: null,
          createDate: new Date(),
          createBy: null,
          activeFlag: true,
          modelDisplayID: null,
          link: null,
        };
        self.setupListSnippet.push(temp);
      } else if (type == 'facebook') {
        temp = {
          socialID: 0,
          name: null,
          secret: null,
          token: null,
          typeSocial: type,
          groupModelID: null,
          modelQuickGroupID: null,
          createDate: new Date(),
          createBy: null,
          activeFlag: true,
          modelDisplayID: null,
          apI_Version: null,
          pageID: null,
        };

        self.setupListFacebook.push(temp);
      } else if (type == 'instagram') {
        temp = {
          socialID: 0,
          name: null,
          secret: null,
          token: null,
          typeSocial: type,
          groupModelID: null,
          modelQuickGroupID: null,
          createDate: new Date(),
          createBy: null,
          activeFlag: true,
          modelDisplayID: null,
          apI_Version: null,
          pageID: null,
        };

        self.setupListInstagram.push(temp);
      }
    },
    cancelDeleteConfig() {
      this.dialog_delete_Config = false;
      this.deleteItem = null;
      this.deleteType = '';
      this.deleteIndex = -1;
    },
    Delete(source, index) {
      this.deleteItem = source;
      this.deleteIndex = index;
      this.dialog_delete_Config = true;
    },
    confirmDeleteConfig() {
      let self = this;
      let source = this.deleteItem;
      let index = this.deleteIndex;
      source.activeFlag = false;
      if (source.socialID == 0) {
        if (source.typeSocial == 'line') {
          self.setupList.splice(index, 1);
        } else if (source.typeSocial == 'ms') {
          self.setupListMS.splice(index, 1);
        } else if (source.typeSocial == 'snippet') {
          self.setupListSnippet.splice(index, 1);
        } else if (source.typeSocial == 'facebook') {
          self.setupListFacebook.splice(index, 1);
        } else if (source.typeSocial == 'instagram') {
          self.setupListInstagram.splice(index, 1);
        }
      }
      self.dialog_delete_Config = false;
    },
    Validate(data) {
      for (const element of data) {
        let temp = element;
        if (temp.activeFlag == true) {
          if (
            temp.name == null ||
            temp.name == '' ||
            (temp.secret == null && temp.typeSocial == 'line') ||
            (temp.secret == '' && temp.typeSocial == 'line') ||
            (temp.token == null && temp.typeSocial == 'line') ||
            (temp.token == '' && temp.typeSocial == 'line') ||
            (temp.modelDisplayID == null && temp.typeSocial == 'snippet') ||
            (temp.secret == null && temp.typeSocial == 'facebook') ||
            (temp.secret == '' && temp.typeSocial == 'facebook') ||
            (temp.token == null && temp.typeSocial == 'facebook') ||
            (temp.token == '' && temp.typeSocial == 'facebook') ||
            (temp.pageID == null && temp.typeSocial == 'facebook') ||
            (temp.pageID == '' && temp.typeSocial == 'facebook') ||
            (temp.secret == null && temp.typeSocial == 'instagram') ||
            (temp.secret == '' && temp.typeSocial == 'instagram') ||
            (temp.token == null && temp.typeSocial == 'instagram') ||
            (temp.token == '' && temp.typeSocial == 'instagram') ||
            (temp.pageID == null && temp.typeSocial == 'instagram') ||
            (temp.pageID == '' && temp.typeSocial == 'instagram')
          ) {
            return false;
          }
          // NEW: Email verification validation
          if (temp.emailVerification) {
            if (!this.ValidateEmailVerificationContacts(temp)) {
              return false;
            }
          }
        }
      }
      return true;
    },
    // NEW: Validation method for email verification contacts
    ValidateEmailVerificationContacts(item) {
      // Get active domains and emails
      const activeDomains = (item.domains || []).filter((domain) => domain.activeFlag !== false);
      const activeEmails = (item.emails || []).filter((email) => email.activeFlag !== false);

      // Must have at least one domain OR one email
      return activeDomains.length > 0 || activeEmails.length > 0;
    },
    ValidateSpecialCharacters(data) {
      let self = this;
      for (const element of data) {
        let temp = element;
        if (self.checkSpecialCharacters(temp.name)) {
          return false;
        }
      }
      return true;
    },
    specialCharacters: function (evt) {
      evt = evt || window.event;
      if (this.specialCharacter.test(evt.key)) {
        evt.preventDefault();
      }
    },
    specialCharactersDomain: function (evt) {
      evt = evt || window.event;
      if (this.specialCharacterDomain.test(evt.key)) {
        evt.preventDefault();
      }
    },
    checkSpecialCharacters: function (text) {
      return this.specialCharacter.test(text);
    },
    specialCharactersOnPaste(evt) {
      let clipboardData = evt.clipboardData || window.clipboardData;
      let pastedData = clipboardData.getData('Text');

      if (this.specialCharacter.test(pastedData)) {
        evt.preventDefault();
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text: this.$t('warningSpecialCharacters'),
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    ClipboardAPIKey(index) {
      let text = this.setupLinkMS[index];
      navigator.clipboard.writeText(text);
    },
    ClipboardScriptSnippet(index) {
      let text = this.setupListSnippet[index].link;
      navigator.clipboard.writeText(text);
    },
    async GetModel() {
      let self = this;
      await self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDModel = dataResponse.data;
          } else {
            self.listDDModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    processVerifiedContacts(data) {
      // Process each item in the data array
      data.forEach((originalItem, index) => {
        const item = this.normalizeItemProperties(originalItem);
        data[index] = item;

        item.domains = [];
        item.emails = [];

        if (!item.selectedDomains) item.selectedDomains = [];
        if (!item.selectedEmails) item.selectedEmails = [];
        if (item.showSuggestion === undefined) item.showSuggestion = false;
        if (item.showEmailSuggestion === undefined) item.showEmailSuggestion = false;
        if (!item.searchDomains) item.searchDomains = '';
        if (!item.searchEmails) item.searchEmails = '';

        const verifiedContacts = item.verifiedContacts || item.VerifiedContacts || [];
        if (verifiedContacts && Array.isArray(verifiedContacts)) {
          verifiedContacts.forEach((contact) => {
            const isActive = contact.activeFlag !== undefined ? contact.activeFlag : contact.ActiveFlag;
            if (isActive) {
              const contactType = contact.contactType || contact.ContactType;
              const contactValue = contact.contactValue || contact.ContactValue;
              const contactID = contact.contactID || contact.ContactID;

              if (contactType === 'Domain') {
                const domainData = {
                  contactID: contactID || 0,
                  contactValue: contactValue,
                  activeFlag: true, // Initialize as active
                };
                if (!item.domains.find((d) => d.contactValue === contactValue)) {
                  item.domains.push(domainData);
                }
              } else if (contactType === 'Email') {
                const emailData = {
                  contactID: contactID || 0,
                  contactValue: contactValue,
                  activeFlag: true, // Initialize as active
                };
                if (!item.emails.find((e) => e.contactValue === contactValue)) {
                  item.emails.push(emailData);
                }
              }
            }
          });
        }
      });
    },

    buildVerifiedContacts(item) {
      const verifiedContacts = [];

      // Add domains (including those marked for deletion)
      if (item.domains && Array.isArray(item.domains)) {
        item.domains.forEach((domainData) => {
          verifiedContacts.push({
            contactID: domainData.contactID || 0,
            contactType: 'Domain',
            contactValue: domainData.contactValue,
            activeFlag: domainData.activeFlag !== false, // Will be false if marked for deletion
            createBy: domainData.createBy || 'admin',
            createDate: domainData.createDate || new Date(),
          });
        });
      }

      // Add emails (including those marked for deletion)
      if (item.emails && Array.isArray(item.emails)) {
        item.emails.forEach((emailData) => {
          verifiedContacts.push({
            contactID: emailData.contactID || 0,
            contactType: 'Email',
            contactValue: emailData.contactValue,
            activeFlag: emailData.activeFlag !== false, // Will be false if marked for deletion
            createBy: emailData.createBy || 'admin',
            createDate: emailData.createDate || new Date(),
          });
        });
      }

      return verifiedContacts;
    },

    // Ensure consistent property naming for API compatibility
    normalizeItemProperties(item) {
      // Ensure all items have consistent property names that match API expectations
      return {
        socialID: item.socialID || item.SocialID || 0,
        name: item.name || item.Name || null,
        secret: item.secret || item.Secret || null,
        token: item.token || item.Token || null,
        typeSocial: item.typeSocial || item.TypeSocial || null,
        groupModelID: item.groupModelID || item.GroupModelID || null,
        modelQuickGroupID: item.modelQuickGroupID || item.ModelQuickGroupID || null,
        modelDisplayID: item.modelDisplayID || item.ModelDisplayID || null,
        shortcutMenuGroupID: item.shortcutMenuGroupID || item.ShortcutMenuGroupID || null,
        apI_Version: item.apI_Version || item.API_Version || null,
        pageID: item.pageID || item.PageID || null,
        createDate: item.createDate || item.CreateDate || new Date(),
        createBy: item.createBy || item.CreateBy || null,
        lineUserID: item.lineUserID || item.LineUserID || null,
        activeFlag: item.activeFlag !== undefined ? item.activeFlag : item.ActiveFlag !== undefined ? item.ActiveFlag : true,
        emailVerification: item.emailVerification !== undefined ? item.emailVerification : item.EmailVerification !== undefined ? item.EmailVerification : false,
        verifiedContacts: item.verifiedContacts || item.VerifiedContacts || [],
        link: item.link || item.Link || null,
        // Preserve domain/email management properties
        domains: item.domains || [],
        emails: item.emails || [],
        selectedDomains: item.selectedDomains || [],
        selectedEmails: item.selectedEmails || [],
        showSuggestion: item.showSuggestion || false,
        showEmailSuggestion: item.showEmailSuggestion || false,
        searchDomains: item.searchDomains || '',
        searchEmails: item.searchEmails || '',
      };
    },

    // Domain validation and management methods
    isValidDomain(domain) {
      if (!domain || typeof domain !== 'string') {
        return false;
      }

      // Basic domain format regex
      const domainRegex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

      // Check if domain matches the pattern and doesn't start/end with hyphen
      if (!domainRegex.test(domain)) {
        return false;
      }

      // Additional checks
      const parts = domain.split('.');

      // Must have at least one dot (e.g., example.com)
      if (parts.length < 2) {
        return false;
      }

      // Each part should not be empty and not exceed 63 characters
      for (let part of parts) {
        if (part.length === 0 || part.length > 63) {
          return false;
        }
      }

      // Last part (TLD) should not be all numeric
      const tld = parts[parts.length - 1];
      if (/^\d+$/.test(tld)) {
        return false;
      }

      return true;
    },

    validateDomains(item, selectedValues) {
      // Check if any domain is invalid to show suggestion
      const hasInvalidDomain = selectedValues.some((chipItem) => {
        const value = typeof chipItem === 'string' ? chipItem : chipItem.value;
        return !this.isValidDomain(value);
      });

      item.showSuggestion = hasInvalidDomain;
    },

    insertDomains(item) {
      const validDomains = item.selectedDomains
        .map((chipItem) => (typeof chipItem === 'string' ? chipItem : chipItem.value))
        .filter((domain) => this.isValidDomain(domain))
        .filter((domain) => !item.domains.find((d) => d.contactValue === domain)); // Avoid duplicates

      if (validDomains.length > 0) {
        validDomains.forEach((domain) => {
          item.domains.push({
            contactID: 0, // New domains don't have contactID yet
            contactValue: domain,
            activeFlag: true, // New domains are active
          });
        });

        item.selectedDomains = [];
      } else {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning') || 'Warning',
          text: 'No valid domains to insert or domains already exist',
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },

    editDomain(item, index) {
      this.openEditDomainDialog(item, index);
    },

    deleteDomain(item, index) {
      const domainToDelete = item.domains[index];
      this.deleteItem = domainToDelete;
      this.deleteType = 'domain';
      this.deleteIndex = index;
      this.currentEditingItem = item;
      this.dialog_delete = true;
    },
    // Email validation and management methods
    isValidEmail(email) {
      if (!email || typeof email !== 'string') {
        return false;
      }

      // Email validation regex
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      // Basic format check
      if (!emailRegex.test(email)) {
        return false;
      }

      // Additional checks
      const parts = email.split('@');
      if (parts.length !== 2) {
        return false;
      }

      const [localPart, domainPart] = parts;

      // Local part validation (before @)
      if (localPart.length === 0 || localPart.length > 64) {
        return false;
      }

      // Domain part validation (after @)
      if (domainPart.length === 0 || domainPart.length > 255) {
        return false;
      }

      // Check for consecutive dots
      if (email.includes('..')) {
        return false;
      }

      // Check for leading/trailing dots in local part
      if (localPart.startsWith('.') || localPart.endsWith('.')) {
        return false;
      }

      return true;
    },

    validateEmails(item, selectedValues) {
      // Check if any email is invalid to show suggestion
      const hasInvalidEmail = selectedValues.some((chipItem) => {
        const value = typeof chipItem === 'string' ? chipItem : chipItem.value;
        return !this.isValidEmail(value);
      });

      item.showEmailSuggestion = hasInvalidEmail;
    },

    removeDomainChip(item, chipValue) {
      const index = item.selectedDomains.findIndex((d) => {
        const value = typeof d === 'string' ? d : d.value;
        return value === chipValue;
      });

      if (index > -1) {
        item.selectedDomains.splice(index, 1);
        setTimeout(() => this.validateDomains(item, item.selectedDomains), 10);
      }
    },

    removeEmailChip(item, chipValue) {
      const index = item.selectedEmails.findIndex((e) => {
        const value = typeof e === 'string' ? e : e.value;
        return value === chipValue;
      });

      if (index > -1) {
        item.selectedEmails.splice(index, 1);
        setTimeout(() => this.validateEmails(item, item.selectedEmails), 10);
      }
    },

    // Filter methods for search functionality
    getFilteredDomains(item) {
      if (!item.domains) return [];

      // Filter out inactive domains
      const activeDomains = item.domains.filter((domain) => domain.activeFlag !== false);

      const searchTerm = (item.searchDomains || '').toLowerCase().trim();
      if (!searchTerm) return activeDomains;

      return activeDomains.filter((domain) => {
        const domainValue = (domain.contactValue || domain || '').toLowerCase();
        return domainValue.includes(searchTerm);
      });
    },

    getFilteredEmails(item) {
      if (!item.emails) return [];

      // Filter out inactive emails
      const activeEmails = item.emails.filter((email) => email.activeFlag !== false);

      const searchTerm = (item.searchEmails || '').toLowerCase().trim();
      if (!searchTerm) return activeEmails;

      return activeEmails.filter((email) => {
        const emailValue = (email.contactValue || email || '').toLowerCase();
        return emailValue.includes(searchTerm);
      });
    },

    // Get filtered index for edit/delete operations
    getOriginalDomainIndex(item, filteredIndex) {
      const filteredDomains = this.getFilteredDomains(item);
      const targetDomain = filteredDomains[filteredIndex];
      return item.domains.findIndex((domain) => {
        const domainValue = domain.contactValue || domain;
        const targetValue = targetDomain.contactValue || targetDomain;
        return domainValue === targetValue;
      });
    },

    getOriginalEmailIndex(item, filteredIndex) {
      const filteredEmails = this.getFilteredEmails(item);
      const targetEmail = filteredEmails[filteredIndex];
      return item.emails.findIndex((email) => {
        const emailValue = email.contactValue || email;
        const targetValue = targetEmail.contactValue || targetEmail;
        return emailValue === targetValue;
      });
    },

    insertEmails(item) {
      const validEmails = item.selectedEmails
        .map((chipItem) => (typeof chipItem === 'string' ? chipItem : chipItem.value))
        .filter((email) => this.isValidEmail(email))
        .filter((email) => !item.emails.find((e) => e.contactValue === email)); // Avoid duplicates

      if (validEmails.length > 0) {
        validEmails.forEach((email) => {
          item.emails.push({
            contactID: 0, // New emails don't have contactID yet
            contactValue: email,
            activeFlag: true, // New emails are active
          });
        });

        item.selectedEmails = [];
      } else {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning') || 'Warning',
          text: 'No valid emails to insert or emails already exist',
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },

    editEmail(item, index) {
      this.openEditEmailDialog(item, index);
    },

    deleteEmail(item, index) {
      const emailToDelete = item.emails[index];

      this.deleteItem = emailToDelete;
      this.deleteType = 'email';
      this.deleteIndex = index;
      this.currentEditingItem = item;
      this.dialog_delete = true;
    },

    deleteAllDomains(item) {
      if (!item.domains || item.domains.length === 0) {
        this.$swal.fire({
          icon: 'info',
          title: 'No Domains',
          text: 'There are no domains to delete',
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }

      this.deleteItem = `all ${item.domains.length} domains`;
      this.deleteType = 'domain-all';
      this.deleteIndex = -1;
      this.currentEditingItem = item;
      this.dialog_delete = true;
    },

    deleteAllEmails(item) {
      if (!item.emails || item.emails.length === 0) {
        this.$swal.fire({
          icon: 'info',
          title: 'No Emails',
          text: 'There are no emails to delete',
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }

      this.deleteItem = `all ${item.emails.length} emails`;
      this.deleteType = 'email-all';
      this.deleteIndex = -1;
      this.currentEditingItem = item;
      this.dialog_delete = true;
    },

    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
      this.deleteType = '';
      this.deleteIndex = -1;
    },

    confirmDelete() {
      switch (this.deleteType) {
        case 'domain':
          this.performDeleteDomain();
          break;
        case 'email':
          this.performDeleteEmail();
          break;
        case 'domain-all':
          this.performDeleteAllDomains();
          break;
        case 'email-all':
          this.performDeleteAllEmails();
          break;
      }
      this.cancelDelete(); // Reset dialog state
    },

    performDeleteDomain() {
      if (this.currentEditingItem && this.deleteIndex !== -1) {
        const domainToDelete = this.currentEditingItem.domains[this.deleteIndex];

        // If the domain has a contactID (exists in database), mark it for deletion
        if (domainToDelete.contactID && domainToDelete.contactID > 0) {
          // Mark as inactive instead of removing from array
          domainToDelete.activeFlag = false;
        } else {
          // If it's a new domain (contactID is 0 or null), remove from array
          this.currentEditingItem.domains.splice(this.deleteIndex, 1);
        }
      }
    },
    performDeleteEmail() {
      if (this.currentEditingItem && this.deleteIndex !== -1) {
        const emailToDelete = this.currentEditingItem.emails[this.deleteIndex];

        // If the email has a contactID (exists in database), mark it for deletion
        if (emailToDelete.contactID && emailToDelete.contactID > 0) {
          // Mark as inactive instead of removing from array
          emailToDelete.activeFlag = false;
        } else {
          // If it's a new email (contactID is 0 or null), remove from array
          this.currentEditingItem.emails.splice(this.deleteIndex, 1);
        }
      }
    },
    performDeleteAllDomains() {
      if (this.currentEditingItem) {
        // Mark all existing domains as inactive, remove new ones
        this.currentEditingItem.domains.forEach((domain) => {
          if (domain.contactID && domain.contactID > 0) {
            domain.activeFlag = false;
          }
        });

        // Remove only new domains (those without contactID)
        this.currentEditingItem.domains = this.currentEditingItem.domains.filter((domain) => domain.contactID && domain.contactID > 0);
      }
    },
    performDeleteAllEmails() {
      if (this.currentEditingItem) {
        // Mark all existing emails as inactive, remove new ones
        this.currentEditingItem.emails.forEach((email) => {
          if (email.contactID && email.contactID > 0) {
            email.activeFlag = false;
          }
        });

        // Remove only new emails (those without contactID)
        this.currentEditingItem.emails = this.currentEditingItem.emails.filter((email) => email.contactID && email.contactID > 0);
      }
    },

    // Edit dialog methods
    openEditDomainDialog(item, index) {
      this.currentEditingConfig = item;
      this.editIndex = index;
      this.editType = 'domain';
      this.editValue = item.domains[index].contactValue || item.domains[index];
      this.dialog_edit = true;
    },

    openEditEmailDialog(item, index) {
      this.currentEditingConfig = item;
      this.editIndex = index;
      this.editType = 'email';
      this.editValue = item.emails[index].contactValue || item.emails[index];
      this.dialog_edit = true;
    },

    cancelEdit() {
      this.dialog_edit = false;
      this.editValue = '';
      this.editType = '';
      this.editIndex = -1;
      this.currentEditingConfig = null;
    },

    confirmEdit() {
      if (!this.isEditValueValid) return;

      const trimmedValue = this.editValue.trim();

      if (this.editType === 'domain') {
        this.performEditDomain(trimmedValue);
      } else if (this.editType === 'email') {
        this.performEditEmail(trimmedValue);
      }

      this.cancelEdit();
    },

    performEditDomain(newValue) {
      if (this.currentEditingConfig && this.editIndex !== -1) {
        // Check if domain already exists
        const existingDomain = this.currentEditingConfig.domains.find((d, idx) => {
          const domainValue = d.contactValue || d;
          return idx !== this.editIndex && domainValue === newValue;
        });

        if (existingDomain) {
          this.$swal.fire({
            icon: 'warning',
            title: 'Duplicate Domain',
            text: 'This domain already exists in the list',
            showConfirmButton: false,
            timer: 2000,
          });
          return;
        }

        // Update the domain
        if (typeof this.currentEditingConfig.domains[this.editIndex] === 'object') {
          this.currentEditingConfig.domains[this.editIndex].contactValue = newValue;
        } else {
          this.currentEditingConfig.domains[this.editIndex] = newValue;
        }
      }
    },

    performEditEmail(newValue) {
      if (this.currentEditingConfig && this.editIndex !== -1) {
        // Check if email already exists
        const existingEmail = this.currentEditingConfig.emails.find((e, idx) => {
          const emailValue = e.contactValue || e;
          return idx !== this.editIndex && emailValue === newValue;
        });

        if (existingEmail) {
          this.$swal.fire({
            icon: 'warning',
            title: 'Duplicate Email',
            text: 'This email already exists in the list',
            showConfirmButton: false,
            timer: 2000,
          });
          return;
        }

        // Update the email
        if (typeof this.currentEditingConfig.emails[this.editIndex] === 'object') {
          this.currentEditingConfig.emails[this.editIndex].contactValue = newValue;
        } else {
          this.currentEditingConfig.emails[this.editIndex] = newValue;
        }
      }
    },

    onExpandChange(index) {
      this.expandedPanel = this.expandedPanel === index ? null : index;
    },
  },
};
</script>
<style scoped>
/* =================== BASE STYLES =================== */
.setup-social {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;
}

.title {
  color: white;
}

.config-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* =================== STICKY TABS STYLES =================== */
.sticky-tabs-container {
  position: sticky;
  top: 0;
  z-index: 100;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: -24px -24px 24px -24px;
  padding: 0 24px;
}

.sticky-tabs {
  background: white !important;
}

/* =================== SAVE BUTTON STYLES =================== */
.save-action-button {
  min-width: 200px !important;
  height: 48px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.save-action-button:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 16px rgba(24, 83, 192, 0.35) !important;
}

.save-action-button:active {
  transform: translateY(0) !important;
}

.save-action-button .v-btn__prepend {
  margin-right: 8px;
}

.sticky-save-btn {
  position: fixed;
  top: 160px;
  right: 30px;
  z-index: 1000;
  max-width: 800px;
  box-shadow: 0px 6px 12px rgba(8, 36, 87, 0.4) !important;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  animation: slideInFromRight 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.sticky-save-btn:hover {
  transform: translateX(-5px) scale(1.02);
  box-shadow: 0px 12px 20px rgba(14, 69, 133, 0.5) !important;
}

@keyframes slideInFromRight {
  from {
    opacity: 0;
    visibility: hidden;
    transform: translateX(100px);
  }

  to {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
  }
}

/* =================== TABS STYLES =================== */
.platform-tabs-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.modern-tabs {
  --v-tabs-height: 90px;
}

.modern-tabs :deep(.v-tabs) {
  height: 50px !important;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
}

.modern-tabs :deep(.v-tabs-slider) {
  transition: transform 0.15s ease-out !important;
}

.platform-tab {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  min-height: 64px !important;
  padding: 5px 24px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.tab-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: column;
}

.tab-text {
  font-size: 0.875rem;
  font-weight: 600;
}

/* Tab Active Colors */
.tab-line :deep(.v-tab--selected) {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%) !important;
  color: #15803d !important;
  transition: all 0.1s ease-out !important;
}

.tab-teams :deep(.v-tab--selected) {
  background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%) !important;
  color: #7c3aed !important;
  transition: all 0.1s ease-out !important;
}

.tab-facebook :deep(.v-tab--selected) {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%) !important;
  color: #2563eb !important;
  transition: all 0.1s ease-out !important;
}

.tab-instagram :deep(.v-tab--selected) {
  background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%) !important;
  color: #db2777 !important;
  transition: all 0.1s ease-out !important;
}

.tab-snippet :deep(.v-tab--selected) {
  background: linear-gradient(135deg, #fed7aa 0%, #fdba74 100%) !important;
  color: #ea580c !important;
  transition: all 0.1s ease-out !important;
}

/* =================== PLATFORM CONTENT =================== */
.platform-window {
  min-height: 600px;
}

.platform-content-wrapper {
  padding: 32px;
}

.platform-header-info {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 16px;
  margin-bottom: 32px;
  border: 1px solid rgba(226, 232, 240, 0.8);
}

.platform-icon-large {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.platform-details {
  flex: 1;
}

.platform-details h2 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.platform-details p {
  color: #6b7280;
  font-size: 1rem;
  margin: 0;
}

.platform-stats {
  display: flex;
  gap: 24px;
}

.stat-item {
  text-align: center;
  padding: 16px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  min-width: 80px;
}

.stat-number {
  display: block;
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
}

.stat-label {
  display: block;
  font-size: 0.75rem;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 4px;
}

.stat-label-1 {
  display: block;
  font-size: 16px;
  color: #171717;
  letter-spacing: 0.5px;
  margin-top: 4px;
}

/* =================== PLATFORM GRADIENTS =================== */
.line-gradient {
  background: #2abf56;
}

.teams-gradient {
  background: linear-gradient(150deg, #5a62c3 223.17%, #4d55bd 5000%, #3940ab 9776.83%);
}

.facebook-gradient {
  background: #3859d0;
}

.instagram-gradient {
  background: radial-gradient(182.61% 44.3% at -16.75% 7.2%, #3771c8 0%, #3771c8 12.8%, rgba(102, 0, 255, 0) 100%),
    radial-gradient(92.18% 99.11% at 26.56% 107.7%, #fd5 0%, #fd5 10%, #ff543e 50%, #c837ab 100%);
}

.snippet-gradient {
  background: linear-gradient(135deg, #e34c26 0%, #f06529 100%);
}

/* =================== CONFIG CARDS =================== */
.configurations-grid {
  min-height: 400px;
}

.config-cards-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

.config-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 2px solid transparent;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  animation: slideInUp 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.config-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
}

.config-card:nth-child(2) {
  animation-delay: 0.1s;
}

.config-card:nth-child(3) {
  animation-delay: 0.2s;
}

.config-card:nth-child(4) {
  animation-delay: 0.3s;
}

.config-card:nth-child(5) {
  animation-delay: 0.3s;
}

.config-card:nth-child(6) {
  animation-delay: 0.3s;
}

/* Platform Specific Card Colors */
.line-card {
  border-top: 4px solid #24b910;
}

.line-card:hover {
  border-color: #1eb910;
  box-shadow: 0 12px 30px rgba(16, 185, 30, 0.1);
}

.teams-card {
  border-top: 4px solid #8b5cf6;
}

.teams-card:hover {
  border-color: #8b5cf6;
  box-shadow: 0 12px 30px rgba(139, 92, 246, 0.15);
}

.facebook-card {
  border-top: 4px solid #3b82f6;
}

.facebook-card:hover {
  border-color: #3b82f6;
  box-shadow: 0 12px 30px rgba(59, 130, 246, 0.15);
}

.instagram-card {
  border-top: 4px solid #ec4899;
}

.instagram-card:hover {
  border-color: #ec4899;
  box-shadow: 0 12px 30px rgba(236, 72, 153, 0.15);
}

.snippet-card {
  border-top: 4px solid #f97316;
}

.snippet-card:hover {
  border-color: #f97316;
  box-shadow: 0 12px 30px rgba(249, 115, 22, 0.15);
}

.config-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px 24px;
  border-bottom: 1px solid #f1f5f9;
}

.config-badge {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  color: #475569;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8125rem;
  font-weight: 600;
}

.teams-badge {
  background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%);
  color: #7c3aed;
}

.facebook-badge {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #2563eb;
}

.instagram-badge {
  background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);
  color: #db2777;
}

.snippet-badge {
  background: linear-gradient(135deg, #fed7aa 0%, #fdba74 100%);
  color: #ea580c;
}

.delete-icon-btn {
  transition: all 0.3s ease;
}

.delete-icon-btn:hover {
  background: rgba(239, 68, 68, 0.1) !important;
  transform: scale(1.1);
}

.config-card-body {
  padding: 24px;
}

/* =================== FORM SECTIONS =================== */
.form-section {
  margin-bottom: 32px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f5f9;
}

/* =================== MODERN INPUT STYLES =================== */
.modern-field :deep(.v-field) {
  background: #fafbfc;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.modern-field :deep(.v-field:hover) {
  background: #f8fafc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.modern-field :deep(.v-field--focused) {
  background: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
}

/* .secure-field :deep(.v-field) {
  background: linear-gradient(135deg, #fef7ed 0%, #ffffff 100%);
} */

/* =================== ADD CONFIG CARD =================== */
.add-config-card {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.add-config-card:hover {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-color: #94a3b8;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
}

.add-card-content {
  text-align: center;
  padding: 32px;
}

.add-card-content h4 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
}

.add-card-content p {
  color: #6b7280;
  margin: 0;
}

/* =================== EMPTY STATE =================== */
.empty-state-card {
  background: white;
  border-radius: 16px;
  padding: 64px 32px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
}

.empty-icon {
  margin-bottom: 24px;
}

.empty-state-card h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
}

.empty-state-card p {
  color: #6b7280;
  font-size: 1rem;
  margin: 0 0 32px 0;
}

.config-count-chip {
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  height: 24px !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
}

.config-count-chip:hover {
  transform: scale(1.1) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25) !important;
}

/* Platform Specific Chip Styles */
.chip-line {
  background: linear-gradient(135deg, #10b951 0%, #059629 100%) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.chip-teams {
  background: linear-gradient(135deg, #665cf6 0%, #3a64ed 100%) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.chip-facebook {
  background: linear-gradient(135deg, #3b82f6, #2563eb) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.chip-instagram {
  background: linear-gradient(120deg, #f01872 0%, #db2754 100%) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.chip-snippet {
  background: linear-gradient(135deg, #f97316, #ea580c) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

/* Tab positioning adjustment for absolute positioned chip */
.platform-tab {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  min-height: 64px !important;
  padding: 5px 24px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important; /* เพื่อให้ chip อยู่ในตำแหน่งที่ถูกต้อง */
}

/* =================== ANIMATIONS =================== */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* =================== RESPONSIVE DESIGN =================== */
@media (max-width: 960px) {
  .sticky-save-btn {
    width: 200px;
    right: 20px;
    top: 120px;
  }

  .platform-header-info {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }

  .platform-stats {
    justify-content: center;
  }

  .config-cards-container {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .config-cards-container {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .platform-tabs-container :deep(.v-tabs) {
    overflow-x: auto;
  }

  .platform-content-wrapper {
    padding: 16px;
  }

  .tab-content {
    flex-direction: row;
  }

  .tab-text {
    display: none;
  }
}

@media (max-width: 600px) {
  .sticky-save-btn {
    width: 180px;
    right: 15px;
    top: 100px;
    font-size: 0.9rem !important;
  }

  .save-action-button {
    min-width: 180px !important;
    height: 44px !important;
    font-size: 0.9rem !important;
  }
}

/* =================== OVERLAY =================== */
.v-overlay--active ~ .setup-container .sticky-save-btn {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

/* =================== COMPACT TEXT BUTTON STYLES =================== */
.compact-text-btn {
  min-width: 120px !important;
  height: 36px !important;
  font-size: 0.85rem !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.025em !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.compact-text-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
}

.compact-text-btn:active {
  transform: translateY(0) !important;
  transition: all 0.1s ease !important;
}

/* Platform-specific compact text variants */
.compact-text-btn.line-btn {
  background-color: #06c226 !important;
  color: white !important;
  border-color: #05a820 !important;
}

.compact-text-btn.line-btn:hover {
  background-color: #0ece2e !important;
  box-shadow: 0 2px 6px rgba(16, 185, 38, 0.25) !important;
}

.compact-text-btn.teams-btn {
  background-color: #403df1 !important;
  color: white !important;
  border-color: #613aed !important;
}

.compact-text-btn.teams-btn:hover {
  background-color: #2f3cfa !important;
  box-shadow: 0 2px 6px rgba(92, 95, 246, 0.25) !important;
}

.compact-text-btn.facebook-btn {
  background-color: #3b82f6 !important;
  color: white !important;
  border-color: #2563eb !important;
}

.compact-text-btn.facebook-btn:hover {
  background-color: #2563eb !important;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.25) !important;
}

.compact-text-btn.instagram-btn {
  background-color: #ec4899 !important;
  color: white !important;
  border-color: #db2777 !important;
}

.compact-text-btn.instagram-btn:hover {
  background-color: #db2777 !important;
  box-shadow: 0 2px 6px rgba(236, 72, 153, 0.25) !important;
}

.compact-text-btn.snippet-btn {
  background-color: #f97316 !important;
  color: white !important;
  border-color: #ea580c !important;
}

.compact-text-btn.snippet-btn:hover {
  background-color: #ea580c !important;
  box-shadow: 0 2px 6px rgba(249, 115, 22, 0.25) !important;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .compact-text-btn {
    min-width: 100px !important;
    height: 32px !important;
    font-size: 0.8rem !important;
  }

  .compact-text-btn .v-icon {
    font-size: 16px !important;
  }
}

/* Extra compact variant */
.compact-text-btn.extra-compact {
  min-width: 90px !important;
  height: 30px !important;
  font-size: 0.75rem !important;
  padding: 0 12px !important;
}

.compact-text-btn.extra-compact .v-icon {
  font-size: 14px !important;
}

.outlined-red-btn {
  border-radius: 12px !important;
  width: 180px;
  height: 40px;
  color: #c32e0e !important;
  font-size: 13px !important;
  background-color: transparent !important;
  border: 1px solid #c32e0e !important;
  text-transform: none !important;
}

.save-action-button-small {
  min-width: 180px !important;
  height: 40px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-radius: 12px !important;
}

.accordion-custom {
  background: linear-gradient(90deg, #fff2f2 0%, #ffded8 100%);
  border-radius: 12px;
  border: 1px solid #f5c2c2;
  overflow: hidden;
  transition: all 0.3s ease;
  margin-bottom: 10px;
}

.accordion-title {
  padding: 12px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
  border-bottom: 1px solid #f1c7c7;
  border-radius: 12px 12px 0 0;
}

.accordion-open {
  border-bottom: 1px solid #f1c7c7;
  border-radius: 12px;
}

/* Inner content (white area) */
.accordion-content {
  background-color: white;
  border-radius: 0 0 12px 12px;
  transition: all 0.3s ease;
}

.accordion-inner-card {
  background-color: transparent;
  box-shadow: none;
}

.config-card-text {
  background: #ffffff;
  border: 1px solid #f1caca;
  border-radius: 16px;
  padding: 24px;
}

.section {
  margin-bottom: 16px;
}

.section-header {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #333;
}

.section-title-1 {
  font-size: 15px;
  font-weight: 600;
}

.switch-hint {
  font-size: 13px;
  color: #777;
  margin-top: -4px;
  margin-left: 36px;
}

.publication-toggle {
  margin: 0 4px;
}

.publication-toggle :deep(.v-switch__track) {
  transform: scale(0.8);
  width: 40px;
  height: 28px;
  border-radius: 999px;
  border: 2px solid transparent;
  background-color: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle :deep(.v-switch__thumb) {
  width: 20px;
  height: 20px;
  box-shadow: none;
  border: 2px solid transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle--active :deep(.v-switch__track) {
  background-color: #ffffff !important;
  border-color: #d32f2f;
}

.publication-toggle--active :deep(.v-switch__thumb) {
  background-color: #d32f2f !important;
  border-color: #d32f2f;
  transform: translateX(-0.5px);
}

.publication-toggle--inactive :deep(.v-switch__track) {
  background-color: #bdbdbd !important;
  border-color: #bdbdbd;
}

.publication-toggle--inactive :deep(.v-switch__thumb) {
  background-color: #ffffff !important;
  border-color: #bdbdbd;
  width: 30px;
  height: 30px;
}

.option-card {
  padding: 5px 16px;
  border-radius: 10px !important;
  background-color: #ededed;
  height: 50px !important;
  border: 1px solid transparent;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  overflow: hidden;
}

.option-header {
  max-width: calc(100% - 50px);
}

/* Container */
.allowed-domain-container {
  background-color: transparent;
}

/* Combobox */
:deep .allowed-domain-combobox .v-field {
  border-radius: 18px;
}
/* Insert button */
.allowed-domain-insert-btn {
  font-weight: 500;
  max-width: 180px;
}

/* Header */
.allowed-domain-title {
  color: #1a1a1a;
}

/* Search bar */
.allowed-domain-search-field {
  max-width: 350px;
}

/* Table */
.allowed-domain-table {
  background-color: #fff;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  margin-top: 10px;
}

/* Table headers */
.allowed-domain-th {
  background-color: #ffeaea;
  color: #171717;
  font-weight: bold !important;
  padding: 10px 16px;
}

/* Table rows */
.allowed-domain-tr:nth-child(even) {
  background-color: #fffafc;
}

.allowed-domain-td {
  padding: 10px 16px;
  border-top: 1px solid #eee;
}

/* Buttons inside table */
.allowed-domain-edit-btn,
.allowed-domain-delete-btn {
  min-width: 0 !important;
}

:deep(.v-table tbody tr:hover) {
  background-color: #f8f9fa !important;
}

:deep(.v-table .v-table__wrapper > table > tbody > tr > td) {
  border: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}

:deep(.v-table .v-table__wrapper > table > thead > tr > th) {
  border: none !important;
}

:deep(.v-table .v-table__wrapper > table > thead > tr th.v-table-column--align-center .v-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}

:deep(.v-table .v-table__wrapper > table > thead > tr th.v-table-column--align-start .v-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}

.allowed-domain-suggestion {
  color: #1a73e8;
  /* Google-style blue */
  font-size: 13px;
  font-weight: 500;
  background-color: #ffffff;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(26, 115, 232, 0.15);
  display: inline-block;
  padding: 4px 10px;
  margin-top: 6px;
  margin-left: 8px;
  transition: all 0.2s ease;
}

/* Custom Delete Dialog Styles */
.delete-dialog-card {
  border-radius: 8px !important;
  padding: 0 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  overflow: hidden !important;
}

.delete-dialog-header {
  background: linear-gradient(180deg, #ffffff 0%, #fff1f0 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 6px 10px 24px !important;
}

.delete-dialog-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #dc3545 !important;
  margin: 0 !important;
}

.delete-close-icon {
  color: #6c757d !important;
  margin: 0 !important;
}

.delete-close-icon:hover {
  background-color: #f8f9fa !important;
}

.delete-dialog-content {
  font-size: 14px !important;
  color: #212529 !important;
  text-align: left !important;
  padding: 24px !important;
  line-height: 1.6 !important;
  border-bottom: 1px solid #dee2e6 !important;
  margin-bottom: 12px !important;
}

.delete-dialog-actions {
  padding: 0 24px 14px 24px !important;
  justify-content: flex-end !important;
  gap: 12px !important;
}

.delete-cancel-btn {
  background-color: white !important;
  color: #495057 !important;
  border: 1px solid #ced4da !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  box-shadow: none !important;
  height: 40px !important;
  min-width: 90px !important;
}

.delete-cancel-btn:hover {
  background-color: #f8f9fa !important;
  border-color: #adb5bd !important;
}

.delete-confirm-btn {
  background-color: #c30000 !important;
  color: white !important;
  border: none !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  height: 40px !important;
  min-width: 100px !important;
}

.delete-confirm-btn:hover {
  background-color: #c82333 !important;
}

.delete-confirm-btn .v-icon {
  margin-right: 6px;
}

/* Custom Edit Dialog Styles */
.edit-dialog-card {
  border-radius: 8px !important;
  padding: 0 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  overflow: hidden !important;
}

.edit-dialog-header {
  background: linear-gradient(180deg, #ffffff 0%, #f0f8ff 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 6px 10px 24px !important;
}

.edit-dialog-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #0d6efd !important;
  margin: 0 !important;
}

.edit-close-icon {
  color: #6c757d !important;
  margin: 0 !important;
}

.edit-close-icon:hover {
  background-color: #f8f9fa !important;
}

.edit-dialog-content {
  padding: 24px !important;
  border-bottom: 1px solid #dee2e6 !important;
  margin-bottom: 12px !important;
}

.edit-dialog-actions {
  padding: 0 24px 14px 24px !important;
  justify-content: flex-end !important;
  gap: 12px !important;
}

.edit-cancel-btn {
  background-color: white !important;
  color: #495057 !important;
  border: 1px solid #ced4da !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  box-shadow: none !important;
  height: 40px !important;
  min-width: 90px !important;
}

.edit-cancel-btn:hover {
  background-color: #f8f9fa !important;
  border-color: #adb5bd !important;
}

.edit-confirm-btn {
  background-color: #0d6efd !important;
  color: white !important;
  border: none !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  height: 40px !important;
  min-width: 100px !important;
}

.edit-confirm-btn:hover {
  background-color: #0b5ed7 !important;
}

.edit-confirm-btn:disabled {
  background-color: #6c757d !important;
  opacity: 0.6 !important;
}

.edit-confirm-btn .v-icon {
  margin-right: 6px;
}

.platform-tabs :deep(.v-tabs) {
  height: 50px !important;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
}

.platform-tabs :deep(.v-tabs-slider) {
  transition: transform 0.15s ease-out !important;
}

.platform-tabs {
  --v-tabs-height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 10px 0 14px;
  position: sticky;
  top: 0;
  z-index: 20;
}

.platform-tab {
  text-transform: none;
  font-weight: 800;
  color: #333;
  border-radius: 16px;
  transition: all 0.25s ease;
  background-color: transparent;
}

.platform-tab .tab-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 14px 20px;
  border-radius: 16px;
  min-width: 210px;
  transition: all 0.25s ease;
}

.platform-tab .tab-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab-chip {
  position: absolute;
  top: -4px;
  right: -30px;
  color: #fff !important;
  font-weight: 600;
  padding: 0 4px;
  font-size: 10px;
  width: 50px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  height: 16px;
}

.tab-label {
  font-weight: 600;
}

/* Platform colors */
.tab-line.active .tab-inner {
  background-color: #e8f9ef;
  color: #00b900;
}

.tab-teams.active .tab-inner {
  background-color: #f0ebff;
  color: #6159e4;
}

.tab-facebook.active .tab-inner {
  background-color: #edf4ff;
  color: #1877f2;
}

.tab-instagram.active .tab-inner {
  background-color: #fff0f5;
  color: #d62976;
}

.tab-snippet.active .tab-inner {
  background-color: #fff5ec;
  color: #ff7f2a;
}

/* Hover */
.platform-tab:hover .tab-inner {
  background-color: #f8f9fa;
}

.action-divider {
  width: 100%;
  height: 1px;
  background: rgba(0, 0, 0, 0.12);
  margin: 25px 0;
  align-self: center;
  border-radius: 1px;
}

.nodatadiv {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.16);
  display: inline-flex;
  padding: 20px;
  justify-content: center;
  align-items: center;
}
.customwidth {
  max-width: 70% !important;
  transition: max-width 0.3s ease;
}
.customwidth-expanded {
  max-width: 100% !important;
  transition: max-width 0.3s ease;
}
.noitemtitle {
  font-size: 16px !important;
  font-weight: 600;
  color: #646464 !important;
  margin: 0 0 8px 0;
}
.noitemdesc {
  font-size: 16px !important;
  color: #646464 !important;
  margin: 0;
}

:deep(.model-group-selector .mdi-menu-down) {
  color: #872612;
  opacity: 1;
  font-size: 28px;
}

.instagram-text-label {
  background: radial-gradient(92.18% 99.11% at 26.56% 107.7%, #fd5 0%, #fd5 10%, #ff543e 50%, #c837ab 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
